// src/config/relicVault/relics.js
//
// Master relic catalog: 675 relics across 9 guilds x 6 rarity tiers (75 per
// guild). Ported verbatim from the designer's handoff (relic-vault-react
// src/data/relics.ts) and cross-checked against relic-vault-master-list.xlsx -
// every id, name, price, description and sprite position matches.
//
// Prices by rarity: Common 110, Uncommon 160, Rare 225, Epic 350,
// Legendary 500, Mythic 800 (see quikcoins_cheat_sheet.xlsx).
//
// Shape of each relic:
//   id          stable id, e.g. "HID-001"
//   guild       guild slug, matches GUILD_DEFS[].id
//   name, desc  display copy
//   rarity      "common" | "uncommon" | "rare" | "epic" | "legendary" | "mythic"
//   rarityLabel display label for the rarity
//   price       QuikCoins
//   sheetClass  sprite sheet, e.g. "vsheet-42" (see images/RelicVault)
//   bgPos       offset of this icon within its sheet, e.g. "-160px -0px"

export const RELIC_CATALOG = [
  {
    "id": "HID-001",
    "guild": "echo",
    "name": "Vampire Fang Necklace",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Harvested vampire fangs on a rope necklace. Echo says it was a gift, though he's vague on who gave it.",
    "sheetClass": "vsheet-0",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-002",
    "guild": "echo",
    "name": "Werewolf Claw Charm",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shed naturally, never taken, this claw has been polished smooth from years of being carried around.",
    "sheetClass": "vsheet-0",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-003",
    "guild": "echo",
    "name": "Witch's Pointy Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A little dusty from sitting in storage, but still perfectly pointed at the tip.",
    "sheetClass": "vsheet-0",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-004",
    "guild": "echo",
    "name": "Zombie Hand Puppet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Used, occasionally, to startle newer guild members. Echo insists it's just for fun.",
    "sheetClass": "vsheet-0",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-005",
    "guild": "echo",
    "name": "Mummy Hand Wrap",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "The wrap found around the hand of an ancient mummy. He is said to walk the halls of Echo's castle.",
    "sheetClass": "vsheet-0",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-006",
    "guild": "echo",
    "name": "Ghost Pirate's Eyepatch",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn over an eye that, as far as anyone can tell, was never actually injured.",
    "sheetClass": "vsheet-1",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-007",
    "guild": "echo",
    "name": "Skeleton Key",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Opens locks it has no business opening, in doors all across the Secret Society's halls.",
    "sheetClass": "vsheet-1",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-008",
    "guild": "echo",
    "name": "Black Cat Charm",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carried for luck, though nobody's entirely sure if it's good luck or bad.",
    "sheetClass": "vsheet-1",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-009",
    "guild": "echo",
    "name": "Raven Feather",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Dropped by a raven that's been seen around the guild's grounds more often than seems normal.",
    "sheetClass": "vsheet-1",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-010",
    "guild": "echo",
    "name": "Bat Wing Cape",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Light enough to flutter in even a gentle breeze, worn by Echo on the guild's spookiest nights.",
    "sheetClass": "vsheet-1",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-011",
    "guild": "echo",
    "name": "Ghoul's Rattling Bone",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Rattles faintly on its own, even sitting perfectly still on a shelf.",
    "sheetClass": "vsheet-2",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-012",
    "guild": "echo",
    "name": "Floating Enchanted Teacup",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Hovers a few inches above its saucer, never once spilling a drop.",
    "sheetClass": "vsheet-2",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-013",
    "guild": "echo",
    "name": "Vampire Bat Wing Pin",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small enamel pin shaped like a bat's wing, popular among newer Secret Society members.",
    "sheetClass": "vsheet-2",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-014",
    "guild": "echo",
    "name": "Spider Ring",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Wraps around the finger like a tiny spider, legs and all, surprisingly comfortable to wear.",
    "sheetClass": "vsheet-2",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-015",
    "guild": "echo",
    "name": "Loch Ness Monster Scale",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Said to have come from a creature nobody's ever fully proven exists. Echo keeps it as a reminder that some mysteries stay mysteries.",
    "sheetClass": "vsheet-2",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-016",
    "guild": "echo",
    "name": "Candy Skull",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Decorated in bright, cheerful colors despite the spooky shape — a little bit of fun mixed into the Secret Society's collection.",
    "sheetClass": "vsheet-3",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-017",
    "guild": "echo",
    "name": "Ghost Costume Mask",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Simple white fabric with two eye holes — the classic look, still a guild favorite every year.",
    "sheetClass": "vsheet-3",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-018",
    "guild": "echo",
    "name": "Haunted Teddy Bear",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Missing one button eye and smelling faintly of an attic nobody remembers visiting.",
    "sheetClass": "vsheet-3",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-019",
    "guild": "echo",
    "name": "Haunted Carousel",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A tiny model carousel that turns slowly on its own, playing a faint, tinny tune.",
    "sheetClass": "vsheet-3",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-020",
    "guild": "echo",
    "name": "Pirate Skeleton",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Still wearing a tattered captain's hat, this little figure guards a treasure chest nobody's opened.",
    "sheetClass": "vsheet-3",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-021",
    "guild": "echo",
    "name": "Enchanted Magnifying Glass",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Reveals tiny details invisible to the naked eye — handy for a guild built on finding hidden things.",
    "sheetClass": "vsheet-4",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-022",
    "guild": "echo",
    "name": "Ghost Wanted Poster",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "The ghost on this poster seems vaguely familiar to Echo. Perhaps a distant aunt or uncle, but he can't be sure.",
    "sheetClass": "vsheet-4",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-023",
    "guild": "echo",
    "name": "Locked Haunted Diary",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sealed tight with an enchanted lock and no key. At night distant cries can be heard coming from inside the diary.",
    "sheetClass": "vsheet-4",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-024",
    "guild": "echo",
    "name": "Skull Candle",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns down slowly from the top, revealing a small carved skull underneath the wax.",
    "sheetClass": "vsheet-4",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-025",
    "guild": "echo",
    "name": "Haunted Jack-in-the-box",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Pops open at random, whether it's been wound or not.",
    "sheetClass": "vsheet-4",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-026",
    "guild": "echo",
    "name": "Pirate Ghost Parrot",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Squawks the same garbled phrase over and over, though nobody's figured out what it's actually trying to say.",
    "sheetClass": "vsheet-5",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-027",
    "guild": "echo",
    "name": "Davy Jones Locker Key",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Rusted through and salt-crusted, this key supposedly opens a locker nobody's ever found.",
    "sheetClass": "vsheet-5",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-028",
    "guild": "echo",
    "name": "Skeleton Pirate Coin",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Tarnished over years of being traded. It is said that whoever carries this coin is cursed to live forever alone. Not you though, of course.",
    "sheetClass": "vsheet-5",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-029",
    "guild": "echo",
    "name": "Vampire Hunters Wooden Stake",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Carved from ancient oak and never actually used, as far as anyone in the guild knows. Echo keeps it more as a conversation piece.",
    "sheetClass": "vsheet-5",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-030",
    "guild": "echo",
    "name": "Creepy Doll",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Nobody's quite sure who left this doll behind, or why its eyes seem to follow you across the room. Echo hasn't moved it in years.",
    "sheetClass": "vsheet-5",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-031",
    "guild": "echo",
    "name": "Witch's Golden Cauldron",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Still faintly warm no matter how long it's been since anything was brewed in it. Echo won't say what the last thing was.",
    "sheetClass": "vsheet-6",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-032",
    "guild": "echo",
    "name": "Graveyard Headstone",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Weathered and cracked, with a name too worn away to read. Echo's tried to find out whose it was. He hasn't had any luck.",
    "sheetClass": "vsheet-6",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-033",
    "guild": "echo",
    "name": "Ghost Pirate's Golden Compass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "The needle doesn't point north — it points toward whatever the holder's most afraid of. Echo doesn't carry it often.",
    "sheetClass": "vsheet-6",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-034",
    "guild": "echo",
    "name": "Cursed Mummy",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Wrapped tight and sealed with a warning nobody's brave enough to translate. Echo keeps it in the deepest part of the collection.",
    "sheetClass": "vsheet-6",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-035",
    "guild": "echo",
    "name": "Haunted Suit of Armor",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Empty, as far as anyone can tell, though it's been found standing in a different spot more than once.",
    "sheetClass": "vsheet-6",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-036",
    "guild": "echo",
    "name": "Skeleton King's Crown",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Passed down from a ruler nobody's found the rest of, this crown still fits perfectly on whoever tries it on. Echo's tried.",
    "sheetClass": "vsheet-7",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-037",
    "guild": "echo",
    "name": "Haunted Cracked Mirror",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "The reflection in this mirror is always half a beat slow, like it's catching up to whoever's looking into it.",
    "sheetClass": "vsheet-7",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-038",
    "guild": "echo",
    "name": "Keep Out Sign",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Posted outside the guild's most mysterious door. This sign has been ignored only once, and that person was never heard from again.",
    "sheetClass": "vsheet-7",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-039",
    "guild": "echo",
    "name": "Poison Apple",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Perfectly polished and suspiciously untouched, this apple has sat in the same bowl for as long as anyone can remember. Nobody's tested it.",
    "sheetClass": "vsheet-7",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-040",
    "guild": "echo",
    "name": "Cobweb Chandelier",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Draped in cobwebs so thick they've become part of the design. Echo's never bothered to clean it — it wouldn't look right otherwise.",
    "sheetClass": "vsheet-7",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-041",
    "guild": "echo",
    "name": "Voodoo Doll",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Stitched together from old fabric scraps, this doll seems harmless enough. Echo still handles it carefully, just in case.",
    "sheetClass": "vsheet-8",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-042",
    "guild": "echo",
    "name": "Haunted Scarecrow",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Stands guard over an empty field nobody actually farms anymore, arms outstretched, watching. Echo swears it's moved, just slightly, more than once.",
    "sheetClass": "vsheet-8",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-043",
    "guild": "echo",
    "name": "Cursed Music Box",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Plays the same eerie tune every time it's wound, never quite finishing before it winds down again.",
    "sheetClass": "vsheet-8",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-044",
    "guild": "echo",
    "name": "Werewolf Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Frozen mid-howl, this statue is carved with enough detail that it's genuinely a little unsettling in dim light.",
    "sheetClass": "vsheet-8",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-045",
    "guild": "echo",
    "name": "Headless Horseman Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Missing exactly what you'd expect, this statue still sits proudly atop its stone horse near the guild's entrance.",
    "sheetClass": "vsheet-8",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-046",
    "guild": "echo",
    "name": "Haunted Rocking Chair",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Rocks gently on its own every so often, even with nobody in it. Echo's stopped trying to explain it.",
    "sheetClass": "vsheet-9",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-047",
    "guild": "echo",
    "name": "Ghost Detector Instrument",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The needle on this dial doesn't move for much, but when it does, it's usually pointing at Echo. Or into a dark corner of the haunted castle.",
    "sheetClass": "vsheet-9",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-048",
    "guild": "echo",
    "name": "Werewolf King's Golden Claw",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Cast in gold from a claw shed during the last full moon, this relic is said to have belonged to the oldest werewolf in the Secret Society's records. Echo keeps it locked away, just in case.",
    "sheetClass": "vsheet-9",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-049",
    "guild": "echo",
    "name": "Witch Queen's Golden Broom",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This broom hasn't swept a single floor in its life — it's strictly for flying, and strictly for the Witch Queen. Echo borrowed it once. He won't say what happened.",
    "sheetClass": "vsheet-9",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-050",
    "guild": "echo",
    "name": "Ghost Pirate's Holographic Hand",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A shimmering, translucent hand that reaches for treasure it can never quite hold. Echo says it's been searching the same chest for two hundred years.",
    "sheetClass": "vsheet-9",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-051",
    "guild": "echo",
    "name": "Cursed Wedding Ring",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Nobody who's worn this ring remembers exactly how they came to own it. Echo keeps it in a box lined with silk, and he never touches it with bare hands.",
    "sheetClass": "vsheet-10",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-052",
    "guild": "echo",
    "name": "Phantom's Golden Mask",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This mask has no face behind it — just a shimmer of light where one should be. Echo says the phantom only shows itself to whoever earns the mask fairly.",
    "sheetClass": "vsheet-10",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-053",
    "guild": "echo",
    "name": "Skeleton Captain's Golden Sword",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Still sharp after all these years underwater, this sword belonged to a captain who refused to abandon ship even after there was nothing left to command. Echo salvaged it from the wreck himself.",
    "sheetClass": "vsheet-10",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-054",
    "guild": "echo",
    "name": "Fortune Tellers Dark Crystal Ball",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Look into this crystal ball and it shows you exactly what you don't want to see. Echo consults it anyway — mostly out of curiosity, occasionally against his better judgment.",
    "sheetClass": "vsheet-10",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-055",
    "guild": "echo",
    "name": "Mummies Golden Canopic Jar",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "One of four jars meant to guard a mummy's most important belongings, this one still hums faintly if you listen closely. Echo's never opened it. Some secrets should stay sealed.",
    "sheetClass": "vsheet-10",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-056",
    "guild": "echo",
    "name": "Giant Golden Spiderweb",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Spun from something that isn't quite silk and doesn't quite sparkle like gold, this web has caught more than a few unlucky wanderers who got too curious. Echo checks it every full moon.",
    "sheetClass": "vsheet-11",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-057",
    "guild": "echo",
    "name": "Witch's Golden Spellbook",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Every spell inside is written backwards, on purpose, so only the most dedicated readers ever figure out how to use it. Echo's tried. He's gotten through maybe a page and a half.",
    "sheetClass": "vsheet-11",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-058",
    "guild": "echo",
    "name": "Grim Reaper's Hourglass",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The sand inside never seems to run out, no matter how long you watch it fall. Echo insists it's just decoration. He never turns his back on it, though.",
    "sheetClass": "vsheet-11",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-059",
    "guild": "echo",
    "name": "Witchs Magical Potion",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Nobody's brave enough to actually drink this potion, but the bottle glows a different color depending on who's holding it. Echo's has never once changed color. Make of that what you will.",
    "sheetClass": "vsheet-11",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-060",
    "guild": "echo",
    "name": "Dracula's Coffin",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Lined in velvet and closed with a lock nobody in the guild has ever picked, this coffin is rumored to still be occupied. Echo's never checked. He'd rather not know.",
    "sheetClass": "vsheet-11",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-061",
    "guild": "echo",
    "name": "Golden Flaming Horse",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This spectral horse gallops in complete silence, hooves wreathed in flame that never actually burns anything. Echo says it only appears to those who've earned its trust.",
    "sheetClass": "vsheet-12",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-062",
    "guild": "echo",
    "name": "Ghost in a Bottle",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Capped tight and sealed with wax, this bottle holds a wisp of something that definitely moves when nobody's looking directly at it. Echo keeps his on a high shelf.",
    "sheetClass": "vsheet-12",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-063",
    "guild": "echo",
    "name": "The Witch Queen's Golden Throne",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from a single block of enchanted wood, this throne only fits whoever the Witch Queen has personally chosen. Echo's sat in it once, very briefly, very nervously.",
    "sheetClass": "vsheet-12",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-064",
    "guild": "echo",
    "name": "Grim Reaper's Scythe",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "The blade never needs sharpening and somehow always catches the light even in total darkness. Echo handles it with both hands and a healthy amount of respect.",
    "sheetClass": "vsheet-12",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-065",
    "guild": "echo",
    "name": "Black Widow Terrarium",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Home to the most deadly spider in the castle. The terrarium has sat undisturbed in the same corner for years.",
    "sheetClass": "vsheet-12",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-066",
    "guild": "echo",
    "name": "Funhouse Mirror",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Look into this mirror and your reflection is always half a second behind you — close enough to be unsettling, never quite close enough to explain. Echo likes to test it on new members.",
    "sheetClass": "vsheet-13",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-067",
    "guild": "echo",
    "name": "Haunted Pirate Ship",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Anchored somewhere nobody can quite find twice, this ghostly ship is said to still be searching for a crew. Echo's been asked to join. He's politely declined, every time.",
    "sheetClass": "vsheet-13",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-068",
    "guild": "echo",
    "name": "Haunted Grand PIano",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This piano plays itself in the dead of night, always the same slow, unfinished melody. Echo's tried to learn the rest of the song. It never quite lets him.",
    "sheetClass": "vsheet-13",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-069",
    "guild": "echo",
    "name": "The Eternal Haunted Castle",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "No matter how many rooms you count, this castle always seems to have one more. Echo's mapped it a dozen times and never gotten the same layout twice.",
    "sheetClass": "vsheet-13",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-070",
    "guild": "echo",
    "name": "Echo Portrait",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This is Echo, headphones on and grinning, caught mid-appearance the way he looks right before he vanishes again. Nobody's quite sure how the portrait was painted — Echo never holds still long enough.",
    "sheetClass": "vsheet-13",
    "bgPos": "-160px -160px"
  },
  {
    "id": "HID-071",
    "guild": "echo",
    "name": "Echo's Founder's Flag",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This flag marks the very first secret Echo ever hid — nobody's found what it was protecting yet. It still flutters even when there's no wind.",
    "sheetClass": "vsheet-14",
    "bgPos": "-0px -0px"
  },
  {
    "id": "HID-072",
    "guild": "echo",
    "name": "Crown of a Thousand Ghosts",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Every ghost the Secret Society has ever encountered is said to have left something of themselves woven into this crown. Echo wears it rarely, and never for long.",
    "sheetClass": "vsheet-14",
    "bgPos": "-160px -0px"
  },
  {
    "id": "HID-073",
    "guild": "echo",
    "name": "Draculas Castle Statue",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "A near-perfect miniature of the castle itself, right down to the crooked tower nobody's ever fully explained. Echo keeps it as a reminder of where the guild's strangest stories began.",
    "sheetClass": "vsheet-14",
    "bgPos": "-320px -0px"
  },
  {
    "id": "HID-074",
    "guild": "echo",
    "name": "Vampire Family Crest",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "The oldest known symbol in the Secret Society's history, passed down through a bloodline nobody has ever fully traced. Echo keeps it locked away — some secrets are better left that way.",
    "sheetClass": "vsheet-14",
    "bgPos": "-0px -160px"
  },
  {
    "id": "HID-075",
    "guild": "echo",
    "name": "Haunted Throne of Secrets",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Whoever sits here is said to hear every secret ever hidden in the Secret Society's halls, all at once. Echo has never dared sit in it himself.",
    "sheetClass": "vsheet-14",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-001",
    "guild": "nova",
    "name": "Gacha Capsule Toy",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Cracked open to reveal a tiny random trinket every time — half the fun is never knowing which one you'll get.",
    "sheetClass": "vsheet-15",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-002",
    "guild": "nova",
    "name": "Neon Vending Machine",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Hums quietly and glows every color at once, dispensing snacks nobody quite remembers stocking it with.",
    "sheetClass": "vsheet-15",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-003",
    "guild": "nova",
    "name": "Holographic Keychain",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shifts its little image depending on the angle you're holding it at — a different scene every time.",
    "sheetClass": "vsheet-15",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-004",
    "guild": "nova",
    "name": "Robot Cat Ears",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Blinks a tiny LED light whenever it's worn, syncing gently to whoever's wearing it.",
    "sheetClass": "vsheet-15",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-005",
    "guild": "nova",
    "name": "Robotic Panda Mask",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Tilts its head slightly on its own, just enough to feel a little too lifelike.",
    "sheetClass": "vsheet-15",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-006",
    "guild": "nova",
    "name": "Neon Karaoke Mic",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Lights up in time with whatever's being sung into it, brighter the louder you go.",
    "sheetClass": "vsheet-16",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-007",
    "guild": "nova",
    "name": "Robotic Firefly Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Flickers exactly like a real firefly, hovering gently in place instead of actually flying.",
    "sheetClass": "vsheet-16",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-008",
    "guild": "nova",
    "name": "Digital Pet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Needs virtual feeding and virtual walks, and somehow still manages to feel like a real responsibility.",
    "sheetClass": "vsheet-16",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-009",
    "guild": "nova",
    "name": "Neon Metalic Umbrella",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Reflects every streetlight it passes under, turning an ordinary walk into a small light show.",
    "sheetClass": "vsheet-16",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-010",
    "guild": "nova",
    "name": "Cyber Crane",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Moves with the same slow, careful steps as a real crane, wings folding with a soft mechanical whir.",
    "sheetClass": "vsheet-16",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-011",
    "guild": "nova",
    "name": "Cherry Blossom Drone",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Releases a tiny shower of pink petals as it flies — purely decorative, but nobody minds.",
    "sheetClass": "vsheet-17",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-012",
    "guild": "nova",
    "name": "Futuristic Arcade Game",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Lights up the whole corner of the workshop, high score list scrolling endlessly at the top.",
    "sheetClass": "vsheet-17",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-013",
    "guild": "nova",
    "name": "Neon Chopstick Set",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows faintly at each tip, mostly useful for finding your food in a very dimly lit room.",
    "sheetClass": "vsheet-17",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-014",
    "guild": "nova",
    "name": "Robotic Origami Swan",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Folds and unfolds itself slowly on a loop, never quite finishing the same fold twice.",
    "sheetClass": "vsheet-17",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-015",
    "guild": "nova",
    "name": "LED Sneakers",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Light up with every step, brighter the faster you're moving.",
    "sheetClass": "vsheet-17",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-016",
    "guild": "nova",
    "name": "Holographic Nova Trading Card",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shows a tiny shifting image of Nova depending on the angle you tilt it.",
    "sheetClass": "vsheet-18",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-017",
    "guild": "nova",
    "name": "Japanese Fan",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Projects a faint shimmer of light with every wave, cooling absolutely nothing but looking great doing it.",
    "sheetClass": "vsheet-18",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-018",
    "guild": "nova",
    "name": "Neon Pagoda Model",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A tiny glowing replica of a traditional pagoda, lit up floor by floor.",
    "sheetClass": "vsheet-18",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-019",
    "guild": "nova",
    "name": "Robotic Hummingbird",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Hovers in place with a faint, steady hum, wings beating too fast to actually see.",
    "sheetClass": "vsheet-18",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-020",
    "guild": "nova",
    "name": "Neon Robotic Alarm Clock",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Wakes you up with a gentle chime instead of a blaring alarm — Nova designed it after one too many rough mornings.",
    "sheetClass": "vsheet-18",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-021",
    "guild": "nova",
    "name": "Anime Poster",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Pinned up in the corner of the workshop, colors still bright despite how long it's been there.",
    "sheetClass": "vsheet-19",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-022",
    "guild": "nova",
    "name": "Neon Ramen Bowl",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows faintly warm even after the ramen inside has gone cold.",
    "sheetClass": "vsheet-19",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-023",
    "guild": "nova",
    "name": "Robot Panda Plushy",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Soft on the outside, quietly mechanical on the inside — it even purrs faintly when squeezed.",
    "sheetClass": "vsheet-19",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-024",
    "guild": "nova",
    "name": "Cyber Cat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Blinks its glowing eyes slowly, tail flicking every so often like it's actually thinking about something.",
    "sheetClass": "vsheet-19",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-025",
    "guild": "nova",
    "name": "Cyber City Bus",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A tiny model bus that rolls a full loop around its miniature route, lights blinking the whole way.",
    "sheetClass": "vsheet-19",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-026",
    "guild": "nova",
    "name": "Robotic Neon Circuit Board",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Lights up in a rippling pattern the moment it's powered on, more decoration than function.",
    "sheetClass": "vsheet-20",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-027",
    "guild": "nova",
    "name": "Cyber Ninja Star",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Perfectly balanced and just sharp enough to feel legitimately impressive, despite being mostly for display.",
    "sheetClass": "vsheet-20",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-028",
    "guild": "nova",
    "name": "Illuminated Hoverboard",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows along its underside, casting a soft colored light just above the ground as it moves.",
    "sheetClass": "vsheet-20",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-029",
    "guild": "nova",
    "name": "Robotic Cricket",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This tiny robot chirps at exactly the right moments to keep the workshop from ever feeling too quiet at night.",
    "sheetClass": "vsheet-20",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-030",
    "guild": "nova",
    "name": "Neon Festival Drum",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each beat sends a ripple of light across the drum's surface, timed perfectly to whatever rhythm's being played.",
    "sheetClass": "vsheet-20",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-031",
    "guild": "nova",
    "name": "Neon Karate Master",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A small robotic figure that runs through the same perfect kata every time it's switched on, glowing faintly with each move.",
    "sheetClass": "vsheet-21",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-032",
    "guild": "nova",
    "name": "Robotic Frog",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Hops exactly like a real frog, right down to the little croak — Nova says it took longer to get the croak right than the hop.",
    "sheetClass": "vsheet-21",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-033",
    "guild": "nova",
    "name": "Hoverbike Model",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A miniature of Nova's actual hoverbike, right down to the tiny working headlight.",
    "sheetClass": "vsheet-21",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-034",
    "guild": "nova",
    "name": "Cyber Kimono",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Woven with thin strands of light-up fiber instead of ordinary thread, this kimono shifts pattern depending on the wearer's mood.",
    "sheetClass": "vsheet-21",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-035",
    "guild": "nova",
    "name": "Neon Ramen Shop Sign",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Flickers on every evening outside Nova's favorite late-night spot, glowing a warm, familiar red.",
    "sheetClass": "vsheet-21",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-036",
    "guild": "nova",
    "name": "Robotic Neon Umbrella",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Opens automatically the second it senses rain, lighting up along each spoke as it goes.",
    "sheetClass": "vsheet-22",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-037",
    "guild": "nova",
    "name": "Neon Torii Gate Charm",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A tiny glowing replica of the gates that mark the entrance to the Inventor Guild's quieter corners.",
    "sheetClass": "vsheet-22",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-038",
    "guild": "nova",
    "name": "Futuristic Bullet Train Model",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Runs a full loop around its tiny track in under ten seconds, lights blurring as it goes.",
    "sheetClass": "vsheet-22",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-039",
    "guild": "nova",
    "name": "Robot Samurai Helmet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Given to Nova from a robot Samurai warrior that she befriended.",
    "sheetClass": "vsheet-22",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-040",
    "guild": "nova",
    "name": "Digital Koi Fish Hologram",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Swims in slow, lazy circles above its little projector base, scales shimmering faintly with each pass.",
    "sheetClass": "vsheet-22",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-041",
    "guild": "nova",
    "name": "Cyber Japanese Lantern",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Glows a soft, shifting color instead of a steady flame, hung outside Nova's workshop door most evenings.",
    "sheetClass": "vsheet-23",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-042",
    "guild": "nova",
    "name": "Neon Dragon Hologram",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Coils and uncoils slowly in midair, all light and no substance, projected from a small base unit Nova built herself.",
    "sheetClass": "vsheet-23",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-043",
    "guild": "nova",
    "name": "Robot Owl Companion",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Blinks its glowing eyes on a slow, steady rhythm and tracks movement across the room with an unsettling amount of precision.",
    "sheetClass": "vsheet-23",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-044",
    "guild": "nova",
    "name": "Neon Basketball Hoop",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Lights up every time something actually goes through the net — which, according to Nova, happens less often than she'd like to admit.",
    "sheetClass": "vsheet-23",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-045",
    "guild": "nova",
    "name": "Robotic Brain",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This little device helps Nova think through complex problems while inventing new creations.",
    "sheetClass": "vsheet-23",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-046",
    "guild": "nova",
    "name": "Robot Sushi Chef",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Slices tiny plastic vegetables with startling precision, over and over, on an endless loop. Nova finds it weirdly relaxing to watch.",
    "sheetClass": "vsheet-24",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-047",
    "guild": "nova",
    "name": "Nova's Neon Katana",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The blade doesn't cut so much as slice clean through static, leaving a trail of violet light in its wake. Nova built it during a late-night invention streak and never quite finished explaining how it works.",
    "sheetClass": "vsheet-24",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-048",
    "guild": "nova",
    "name": "Neon Pinball Machine",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Every bumper on this machine lights up in a different neon color, and the high score has stayed the same for longer than anyone can explain. Nova insists she hasn't rigged it. Nobody quite believes her.",
    "sheetClass": "vsheet-24",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-049",
    "guild": "nova",
    "name": "Digital Aquarium",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The fish inside this tank aren't real, but they swim, school, and even seem to recognize faces after a while. It never needs feeding, which Nova considers its best feature.",
    "sheetClass": "vsheet-24",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-050",
    "guild": "nova",
    "name": "Robotic Dragonfly",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This tiny drone hovers exactly like a real dragonfly, right down to the way its wings catch the light. Nova built a whole swarm of them before deciding one was plenty.",
    "sheetClass": "vsheet-24",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-051",
    "guild": "nova",
    "name": "Holographic Bamboo Tree",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Sway it gently and the whole tree shimmers and resets, glowing faintly green even in a pitch-dark room. It's Nova's favorite piece of decoration in the whole workshop.",
    "sheetClass": "vsheet-25",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-052",
    "guild": "nova",
    "name": "Robot Butterfly",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Its wings are thin sheets of circuitry, and it flutters just like a real butterfly — right down to landing on your hand if you hold still long enough. Nova calls it her first successful flight test.",
    "sheetClass": "vsheet-25",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-053",
    "guild": "nova",
    "name": "Neon Dragon Scupture",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Wired with looping light strands instead of scales, this dragon sculpture seems to breathe when its lights pulse in sequence. It took Nova three tries to get the timing right.",
    "sheetClass": "vsheet-25",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-054",
    "guild": "nova",
    "name": "Robot Ninja",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Every piece of this gear is silent by design — no clicks, no whirs, nothing to give away a robot ninja's position. Nova tested it by trying to sneak up on herself. It worked.",
    "sheetClass": "vsheet-25",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-055",
    "guild": "nova",
    "name": "Japanese Neon Sign",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The characters on this sign shift color depending on the time of day, though nobody's entirely sure what it says. Nova likes it that way.",
    "sheetClass": "vsheet-25",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-056",
    "guild": "nova",
    "name": "Holographic Japanese Bridge",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Walk across and the bridge flickers faintly beneath your feet, solid enough to hold weight but glowing like it isn't really there. Nova built it to connect two workbenches that were just a little too far apart.",
    "sheetClass": "vsheet-26",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-057",
    "guild": "nova",
    "name": "Nova Kimono Sculpture",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A tiny sculpture of Nova in full formal kimono, circuitry patterns woven straight into the fabric design. It's one of the only pieces in the workshop Nova didn't build herself.",
    "sheetClass": "vsheet-26",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-058",
    "guild": "nova",
    "name": "Metalic Neon Cherry Blossom Tree",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Each petal is a paper-thin sheet of metal that catches neon light and scatters it in tiny reflections. It sheds a new 'blossom' every few weeks, and Nova always saves them.",
    "sheetClass": "vsheet-26",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-059",
    "guild": "nova",
    "name": "Glowing Cyber Bonsai Tree",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Trimmed with the same care as a real bonsai, this tiny tree glows faintly from within, its wires disguised as roots. Nova says patience is the whole point of both bonsai and circuitry.",
    "sheetClass": "vsheet-26",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-060",
    "guild": "nova",
    "name": "Cyber Tiger",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Built with joints that move as smoothly as a real tiger's, this robot prowls the workshop floor on quiet patrol. Nova programmed it herself, mostly for company.",
    "sheetClass": "vsheet-26",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-061",
    "guild": "nova",
    "name": "Family Kart Glowing Sign",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "The neon sign flickers on every evening outside of Nova's favorite convenience store. She goes here to get her favorite nuts and bolts.",
    "sheetClass": "vsheet-27",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-062",
    "guild": "nova",
    "name": "Neon Tokyo Tower Model",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "A miniature replica of the tallest tower in the neon skyline, lit from base to spire with real working lights. Nova built it entirely from spare parts.",
    "sheetClass": "vsheet-27",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-063",
    "guild": "nova",
    "name": "Cyber City Wand",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Wave this wand near any piece of tech in the workshop and it hums briefly to life, just to say hello. Nova insists it's not magic. It's just very good engineering.",
    "sheetClass": "vsheet-27",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-064",
    "guild": "nova",
    "name": "Neon Dragon Kite",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Wired with lights instead of just fabric, this kite traces a glowing dragon shape across the night sky whenever it flies. Nova only flies it after dark, for effect.",
    "sheetClass": "vsheet-27",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-065",
    "guild": "nova",
    "name": "Cyber Shrine Gate",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This towering gate marks the entrance to the Inventor Guild's quietest corner, glowing faintly even when every other light in the workshop is off. Nova built it to feel like stepping somewhere sacred.",
    "sheetClass": "vsheet-27",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-066",
    "guild": "nova",
    "name": "Robotic Sushi Roll",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Part decoration, part inside joke, this robotic sushi roll lights up and rolls gently across the table on tiny wheels. Nova built it during a very hungry late night.",
    "sheetClass": "vsheet-28",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-067",
    "guild": "nova",
    "name": "Neon Dragon Float",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Built for the Inventor Guild's biggest celebrations, this float rolls through the neon streets lit up from every angle. Nova rides it once a year and refuses to say how.",
    "sheetClass": "vsheet-28",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-068",
    "guild": "nova",
    "name": "Robotic Dragon Egg",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This egg hums faintly with power and occasionally flickers with tiny sparks, though nothing's hatched yet. Nova checks its charge every morning, just in case today's the day.",
    "sheetClass": "vsheet-28",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-069",
    "guild": "nova",
    "name": "Tiger Emperor's Crown",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Worn only during the Inventor Guild's biggest showcase, this crown lights up along every seam when its wearer's latest invention actually works.",
    "sheetClass": "vsheet-28",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-070",
    "guild": "nova",
    "name": "Nova Portrait",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This is Nova, lit up in neon purple, exactly as she appears the moment a new invention powers on. Nova's eyes follow you wherever you go. One of her proudest inventions.",
    "sheetClass": "vsheet-28",
    "bgPos": "-160px -160px"
  },
  {
    "id": "INV-071",
    "guild": "nova",
    "name": "Nova's Founder's Flag",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This flag marks the spot where Nova built her very first invention, back before the Inventor Guild had any circuits to speak of. It still hums faintly with leftover power.",
    "sheetClass": "vsheet-29",
    "bgPos": "-0px -0px"
  },
  {
    "id": "INV-072",
    "guild": "nova",
    "name": "Golden Robot Samurai",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Built joint by joint over months of late nights, this samurai stands guard at the workshop entrance, motionless until something crosses its sensors.",
    "sheetClass": "vsheet-29",
    "bgPos": "-160px -0px"
  },
  {
    "id": "INV-073",
    "guild": "nova",
    "name": "Crown of the Circuit Kingdom",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Set at the center of the Inventor Guild's main hall, this crown hums faintly with the combined hum of every invention ever built nearby.",
    "sheetClass": "vsheet-29",
    "bgPos": "-320px -0px"
  },
  {
    "id": "INV-074",
    "guild": "nova",
    "name": "Nova's Cyber Throne",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Nova's command seat, wired directly into the heart of the Inventor Guild's network. From here she can see every invention, every circuit, every glowing sign in the guild at once.",
    "sheetClass": "vsheet-29",
    "bgPos": "-0px -160px"
  },
  {
    "id": "INV-075",
    "guild": "nova",
    "name": "Robot Dragon",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "The single most advanced creation the Inventor Guild has ever powered on — part machine, part myth. Nova built it in secret, and it's said to still be learning.",
    "sheetClass": "vsheet-29",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-001",
    "guild": "astra",
    "name": "Moonsilk Ribbon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Soft as moonlight and just as pale, this ribbon never seems to tangle no matter how it's tied.",
    "sheetClass": "vsheet-30",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-002",
    "guild": "astra",
    "name": "Pearl Raindrop Charm",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Each little charm is shaped like a single drop of rain, frozen mid-fall and never quite landing.",
    "sheetClass": "vsheet-30",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-003",
    "guild": "astra",
    "name": "Aurora Scarf",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shifts color gently as it's worn, cycling slowly through the same colors as the northern lights.",
    "sheetClass": "vsheet-30",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-004",
    "guild": "astra",
    "name": "Lavender Dream Petal",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A single petal that never wilts, kept for the faint, calming scent it carries.",
    "sheetClass": "vsheet-30",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-005",
    "guild": "astra",
    "name": "Rainbow Flower",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Blooms in every color at once instead of picking just one, somehow without looking messy about it.",
    "sheetClass": "vsheet-30",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-006",
    "guild": "astra",
    "name": "Prism Bracelet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Catches sunlight and scatters it into tiny rainbows across whatever surface is nearby.",
    "sheetClass": "vsheet-31",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-007",
    "guild": "astra",
    "name": "Rainbow Owl Feather",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shed naturally, this feather shimmers through every color depending on the angle it's held.",
    "sheetClass": "vsheet-31",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-008",
    "guild": "astra",
    "name": "Pearl Binoculars",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Trimmed in real pearl, these binoculars somehow make even ordinary clouds look a little more magical.",
    "sheetClass": "vsheet-31",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-009",
    "guild": "astra",
    "name": "Pearl Owl Sculpture",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carved from a single smooth pearl, this owl watches over Astra's palace with wide, patient eyes.",
    "sheetClass": "vsheet-31",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-010",
    "guild": "astra",
    "name": "Rainbow Bird Bath",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "The water inside always seems to catch a little rainbow, even on cloudy days.",
    "sheetClass": "vsheet-31",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-011",
    "guild": "astra",
    "name": "Crystal Dove",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carved from clear crystal, this dove seems to glow faintly whenever light passes through it.",
    "sheetClass": "vsheet-32",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-012",
    "guild": "astra",
    "name": "Cloud Rose",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Soft as a cloud and somehow just as light, this rose never quite droops.",
    "sheetClass": "vsheet-32",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-013",
    "guild": "astra",
    "name": "Rainbow Spear",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Too delicate for real use, this spear exists mostly for ceremony, catching light along its full length.",
    "sheetClass": "vsheet-32",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-014",
    "guild": "astra",
    "name": "Moonbeam Hair Clip",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows the faintest silver, just enough to catch the eye without being too bright.",
    "sheetClass": "vsheet-32",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-015",
    "guild": "astra",
    "name": "Cloud Dragon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Small, soft-looking, and entirely harmless — this little dragon drifts more than it flies.",
    "sheetClass": "vsheet-32",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-016",
    "guild": "astra",
    "name": "Rainbow Kaleidescope",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Every turn reveals a new pattern, somehow always in perfect, shifting color.",
    "sheetClass": "vsheet-33",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-017",
    "guild": "astra",
    "name": "Rainbow Owl Nest",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Woven from strands of light instead of twigs, this little nest glows softly at night.",
    "sheetClass": "vsheet-33",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-018",
    "guild": "astra",
    "name": "Rainbow Dragonfly",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Flits through Astra's gardens leaving the faintest shimmer of color behind it.",
    "sheetClass": "vsheet-33",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-019",
    "guild": "astra",
    "name": "Astra's Starlight Tapestry",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Woven by Astra herself, this tapestry seems to shift its pattern slowly, like the stars are actually moving across it.",
    "sheetClass": "vsheet-33",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-020",
    "guild": "astra",
    "name": "Prism Goblet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Catches the light beautifully whenever it's raised, scattering tiny rainbows across the table.",
    "sheetClass": "vsheet-33",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-021",
    "guild": "astra",
    "name": "Crystal Kayak",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Light enough to lift with one hand, yet sturdy enough to glide smoothly across the calmest water.",
    "sheetClass": "vsheet-34",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-022",
    "guild": "astra",
    "name": "Cloud Surfboard",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Rides on nothing but air, gliding smoothly just above the ground.",
    "sheetClass": "vsheet-34",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-023",
    "guild": "astra",
    "name": "Cloud Parachute",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Drifts down slower and softer than any ordinary parachute, landing as gently as a cloud settling.",
    "sheetClass": "vsheet-34",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-024",
    "guild": "astra",
    "name": "Rainbow Shield",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Used to fight in the most mystical of wars. Whoever carries this shield can never be defeated.",
    "sheetClass": "vsheet-34",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-025",
    "guild": "astra",
    "name": "Aurora Wingsuit",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Whoever wears this can glide through the skies like a rainbow shooting across the sky.",
    "sheetClass": "vsheet-34",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-026",
    "guild": "astra",
    "name": "Cloud Cotton Candy",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Light as air and somehow always the same fluffy texture, no matter how long it's been sitting out.",
    "sheetClass": "vsheet-35",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-027",
    "guild": "astra",
    "name": "Rainbow Crystal Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows a different color depending on the time of day, cycling gently from dawn to dusk.",
    "sheetClass": "vsheet-35",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-028",
    "guild": "astra",
    "name": "Sky Racing Trophy",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Awarded for the fastest lap through Astra's cloud palace's open skies, engraved fresh each season.",
    "sheetClass": "vsheet-35",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-029",
    "guild": "astra",
    "name": "Rainbow Harp",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each string is a different color, and plucking them in order produces a scale that somehow always sounds like sunrise.",
    "sheetClass": "vsheet-35",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-030",
    "guild": "astra",
    "name": "Opal Tiara",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Set with opals that shift color depending on the light, this tiara is a favorite among Astra's most trusted guests.",
    "sheetClass": "vsheet-35",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-031",
    "guild": "astra",
    "name": "Rainbow Crystal Battle Axe",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A relic from the battles of the sky kingdom. This axe ensures a swift victory in any battle.",
    "sheetClass": "vsheet-36",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-032",
    "guild": "astra",
    "name": "Moonlit Music Box",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Plays a soft, slow melody only when the moon's actually visible through the window. On cloudy nights, it stays silent.",
    "sheetClass": "vsheet-36",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-033",
    "guild": "astra",
    "name": "Cloud Chariot",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Rides smoothly across open sky, its wheels somehow never quite touching anything solid underneath.",
    "sheetClass": "vsheet-36",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-034",
    "guild": "astra",
    "name": "Pearl Rain Umbrella",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shields perfectly from rain, though Astra says it's rarely needed — it never seems to rain in her cloud palace.",
    "sheetClass": "vsheet-36",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-035",
    "guild": "astra",
    "name": "Opal Storm Cloak",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shimmers faintly whenever a storm's approaching, giving the wearer just enough warning to find shelter.",
    "sheetClass": "vsheet-36",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-036",
    "guild": "astra",
    "name": "Crystal Owl",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Sits perfectly still for hours, then blinks its crystal eyes at exactly the moment you stop watching.",
    "sheetClass": "vsheet-37",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-037",
    "guild": "astra",
    "name": "Opal Hourglass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "The sand inside shifts color as it falls, cycling slowly through every shade of the opal it's named for.",
    "sheetClass": "vsheet-37",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-038",
    "guild": "astra",
    "name": "Crystal Bow",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This bow shoots an aurora across the skies when fired.",
    "sheetClass": "vsheet-37",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-039",
    "guild": "astra",
    "name": "Gilded Dream Fan",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Fold it open and a faint, pleasant breeze seems to follow, even indoors, even on the stillest day.",
    "sheetClass": "vsheet-37",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-040",
    "guild": "astra",
    "name": "Rainbow Crystal Piano",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each key is a different color, and playing them in sequence sends a faint shimmer of light rippling across the room.",
    "sheetClass": "vsheet-37",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-041",
    "guild": "astra",
    "name": "Cloud Owl",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Soft, silent, and nearly weightless, this little owl statue seems to drift rather than sit on its shelf.",
    "sheetClass": "vsheet-38",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-042",
    "guild": "astra",
    "name": "Moonlit Dream Bell",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Rings only once the moon's fully risen, a soft chime that seems to invite good dreams.",
    "sheetClass": "vsheet-38",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-043",
    "guild": "astra",
    "name": "Pearl Cloud Slipper Pair",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Light as air and always warm. Whoever wears them glides across the floor without ever touching the ground.",
    "sheetClass": "vsheet-38",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-044",
    "guild": "astra",
    "name": "Rainbow Comet Car",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Trails a faint streak of color behind it wherever it drives, like a tiny comet passing by.",
    "sheetClass": "vsheet-38",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-045",
    "guild": "astra",
    "name": "Crystal Old Fashioned Plane",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A small crystal model of an early flying machine, wings catching the light beautifully whenever it's turned.",
    "sheetClass": "vsheet-38",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-046",
    "guild": "astra",
    "name": "Silver Moon Compass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Always points toward the moon, no matter the time of day or how cloudy the sky gets.",
    "sheetClass": "vsheet-39",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-047",
    "guild": "astra",
    "name": "Astra's Cloud Palace Key",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from a single flawless pearl and always warm to the touch, this key opens the gate to Astra's cloud palace — but only for those who've truly earned the way in. Astra keeps a spare hidden somewhere nobody's found yet.",
    "sheetClass": "vsheet-39",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-048",
    "guild": "astra",
    "name": "Liquid Gold Dream Orb",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Tip this orb gently and the gold inside swirls like liquid sunlight, never quite settling. Astra says it holds a piece of every dream she's ever had.",
    "sheetClass": "vsheet-39",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-049",
    "guild": "astra",
    "name": "Crystal Dagger",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This dagger was recovered from the mountains in the skies. Light catches on this dagger and scatters across the room bringing good fortune to its owner.",
    "sheetClass": "vsheet-39",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-050",
    "guild": "astra",
    "name": "Crystal Pegasus",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from a single flawless crystal, this tiny pegasus seems to shift its wings when the light hits it just right. Astra says it's the closest thing to a real one she's ever seen.",
    "sheetClass": "vsheet-39",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-051",
    "guild": "astra",
    "name": "Aurora Snowglobe",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Shake this snowglobe and the aurora inside swirls in real color, not just glitter. Astra keeps hers on the windowsill, catching the last light of every evening.",
    "sheetClass": "vsheet-40",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-052",
    "guild": "astra",
    "name": "Crystal Rainbow Sail Boat",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This tiny boat sails on nothing but moonlight, its crystal hull catching every color of the rainbow as it drifts. Astra says it never needs wind — just wonder.",
    "sheetClass": "vsheet-40",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-053",
    "guild": "astra",
    "name": "Pearl Palace Gate",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from a single enormous pearl, this gate is the entrance to Astra's cloud palace — and it only opens for those who've truly earned the way in.",
    "sheetClass": "vsheet-40",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-054",
    "guild": "astra",
    "name": "Rainbow Swan",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Feathers shimmering every color at once, this swan glides without ever seeming to touch the clouds beneath it. Astra says it visits her balcony most mornings.",
    "sheetClass": "vsheet-40",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-055",
    "guild": "astra",
    "name": "Dream Fountain",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The water in this fountain never splashes — it just glows and shifts color, quietly, endlessly. Astra says watching it is the best way to fall asleep.",
    "sheetClass": "vsheet-40",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-056",
    "guild": "astra",
    "name": "Opaline Throne",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Smaller than Astra's own throne, but carved from the same opal, this seat is reserved for her most trusted visitors. Few have ever sat in it.",
    "sheetClass": "vsheet-41",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-057",
    "guild": "astra",
    "name": "Aurora Wing Cloak",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Woven from strands of captured aurora light, this cloak shimmers faintly even in complete darkness. Astra wears hers only on the clearest nights.",
    "sheetClass": "vsheet-41",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-058",
    "guild": "astra",
    "name": "Rainbow Wand",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Wave this wand and it leaves a trail of color hanging in the air for a few seconds before fading. Astra insists it isn't magic. Nobody quite believes her.",
    "sheetClass": "vsheet-41",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-059",
    "guild": "astra",
    "name": "Rainbow Sword",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Used by the guards of Astra's palace to protect it. Harnesses the power of the skies to defend the palace.",
    "sheetClass": "vsheet-41",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-060",
    "guild": "astra",
    "name": "Crystal Rainbow Unicorn",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from crystal that seems to hold every color at once, this unicorn statue shifts its shimmer depending on the angle you view it from. Astra says it's the truest likeness anyone's ever managed.",
    "sheetClass": "vsheet-41",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-061",
    "guild": "astra",
    "name": "Crystal Gong",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Strike the gong and you will have 7 years of good luck. Astra only lets those with pure hearts strike it.",
    "sheetClass": "vsheet-42",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-062",
    "guild": "astra",
    "name": "Crystal Rainbow Trading Card",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This card shifts its image depending on the angle, cycling gently through scenes from Astra's own cloud palace and through the magical creatures that roam the skies. Collectors consider it one of the hardest to find in mint condition.",
    "sheetClass": "vsheet-42",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-063",
    "guild": "astra",
    "name": "Rainbow Stag of Northern Lights",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This stag's antlers seem to be made of captured aurora light, shifting color with every step it takes. Astra says it only appears on the clearest nights.",
    "sheetClass": "vsheet-42",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-064",
    "guild": "astra",
    "name": "Cloud Palace Chandelier",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Hanging from the tallest ceiling in Astra's palace, this chandelier doesn't use candles at all — just captured starlight, held steady in glass. It's never once gone dark.",
    "sheetClass": "vsheet-42",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-065",
    "guild": "astra",
    "name": "Crystal Rainbow Torch",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This torch burns with light instead of flame, shifting gently through every color of the rainbow as it burns. Astra says it never needs relighting.",
    "sheetClass": "vsheet-42",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-066",
    "guild": "astra",
    "name": "Gilded Aurora Wings",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Trimmed in real gold and shimmering faintly with captured aurora light, these wings are almost too beautiful to actually wear. Astra keeps hers mounted, just for display, most days.",
    "sheetClass": "vsheet-43",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-067",
    "guild": "astra",
    "name": "Astra's Crystal Moonlit Sceptor",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from a single piece of moonlit crystal, this scepter hums faintly whenever Astra holds it. She says it's just for ceremony. Nobody's entirely sure that's true.",
    "sheetClass": "vsheet-43",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-068",
    "guild": "astra",
    "name": "Astra's Crown of Infinite Wonder",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "A crown said to hold a piece of every wonder Astra has ever discovered. A truly legendary relic.",
    "sheetClass": "vsheet-43",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-069",
    "guild": "astra",
    "name": "Rainbow Dragon Egg",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This egg shifts through every color of the rainbow depending on the light, and has never once shown any sign of hatching. Astra says some things are more magical left exactly as they are.",
    "sheetClass": "vsheet-43",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-070",
    "guild": "astra",
    "name": "Cloud Palace Throne",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Astra's own throne, spun from moonsilk and set with opal, floating gently above the clouds. Only the most accomplished collectors in the entire game ever see it up close.",
    "sheetClass": "vsheet-43",
    "bgPos": "-160px -160px"
  },
  {
    "id": "MAS-071",
    "guild": "astra",
    "name": "Astra Portrait",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This is Astra, wings spread and eyes full of wonder, painted the way she always looks gazing out over her cloud palace. This painting has hung on the walls of her palace for over 100 years.",
    "sheetClass": "vsheet-44",
    "bgPos": "-0px -0px"
  },
  {
    "id": "MAS-072",
    "guild": "astra",
    "name": "Astra's Founder's Flag",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This flag has flown above Astra's cloud palace since the very first rainbow bridge was built. It never quite touches the ground — much like everything else in her realm.",
    "sheetClass": "vsheet-44",
    "bgPos": "-160px -0px"
  },
  {
    "id": "MAS-073",
    "guild": "astra",
    "name": "Crystal Dragon Mask",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Worn only during Astra's most important ceremonies, this crystal mask catches the light in a way that makes the wearer seem to glow from within.",
    "sheetClass": "vsheet-44",
    "bgPos": "-320px -0px"
  },
  {
    "id": "MAS-074",
    "guild": "astra",
    "name": "Rainbow Crystal Dragon Sculpture",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "This dragon comes alive at night, keeping watch over Astra's palace, welcoming friends and scaring away darkness.",
    "sheetClass": "vsheet-44",
    "bgPos": "-0px -160px"
  },
  {
    "id": "MAS-075",
    "guild": "astra",
    "name": "Astra's Cloud Palace",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "The palace where dreams become real and everything is infinitely beautiful. Having access to this palace means you are one of Astra's most trusted friends.",
    "sheetClass": "vsheet-44",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-001",
    "guild": "newton",
    "name": "Exploding Volcano Cupcake",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Fizzes and pops the second you bite into it — Newton's third attempt at a 'safe' science-fair snack.",
    "sheetClass": "vsheet-45",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-002",
    "guild": "newton",
    "name": "Rubber Chicken Alarm",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Squawks loudly at exactly the wrong moment, every single time, without fail.",
    "sheetClass": "vsheet-45",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-003",
    "guild": "newton",
    "name": "Grumpy Toaster",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns the toast about as often as it toasts it properly, but Newton refuses to replace it.",
    "sheetClass": "vsheet-45",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-004",
    "guild": "newton",
    "name": "Banana Peel Roller Skates",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Slippery, unpredictable, and somehow still Newton's preferred way to cross the workshop floor.",
    "sheetClass": "vsheet-45",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-005",
    "guild": "newton",
    "name": "Tin Foil Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Doesn't actually do anything, as far as anyone can tell, but Newton wears it 'just in case.'",
    "sheetClass": "vsheet-45",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-006",
    "guild": "newton",
    "name": "Indestructible Duct Tape",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Holds together absolutely everything in the workshop, including at least one chair that should've been replaced years ago.",
    "sheetClass": "vsheet-46",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-007",
    "guild": "newton",
    "name": "Popcorn-Powered Rocket",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Launches a few feet into the air on a good day, powered entirely by the pressure of popping kernels.",
    "sheetClass": "vsheet-46",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-008",
    "guild": "newton",
    "name": "Cracked Safety Goggles",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Still technically works, even with the crack running straight across one lens.",
    "sheetClass": "vsheet-46",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-009",
    "guild": "newton",
    "name": "Pickle Walkie Talkie",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Crackles with static more often than actual words, but Newton insists it's 'mostly' functional.",
    "sheetClass": "vsheet-46",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-010",
    "guild": "newton",
    "name": "Fake Mustache Disguise Kit",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Fools absolutely nobody, but Newton wears it to the workshop anyway, for morale.",
    "sheetClass": "vsheet-46",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-011",
    "guild": "newton",
    "name": "Paperclip Wrench",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bent into the shape of a wrench out of pure necessity during a late-night repair.",
    "sheetClass": "vsheet-47",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-012",
    "guild": "newton",
    "name": "Bubblegum Bandage",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sticks a little too well and smells faintly of bubblegum — Newton's proudest 'multi-use invention.'",
    "sheetClass": "vsheet-47",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-013",
    "guild": "newton",
    "name": "Fall Proof Sumo Suit",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Padded thick enough to survive Newton's most enthusiastic test falls without a scratch.",
    "sheetClass": "vsheet-47",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-014",
    "guild": "newton",
    "name": "Persistent Pogo Stick",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Never quite stops bouncing on its own, even after you've stepped off.",
    "sheetClass": "vsheet-47",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-015",
    "guild": "newton",
    "name": "Bent But Not Broken Magic Spoon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bent from an early experiment gone wrong, but it still stirs a pot just fine.",
    "sheetClass": "vsheet-47",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-016",
    "guild": "newton",
    "name": "Rebuilt From Scratch Radio",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Took four attempts to get working, and now it picks up stations that shouldn't exist.",
    "sheetClass": "vsheet-48",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-017",
    "guild": "newton",
    "name": "Try Again Trampoline",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bounces you right back up after every failed attempt, literally and a little bit metaphorically.",
    "sheetClass": "vsheet-48",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-018",
    "guild": "newton",
    "name": "Melted Ice Cream Cone",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Melted mid-invention and never quite got cleaned up — now it's just part of the workshop décor.",
    "sheetClass": "vsheet-48",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-019",
    "guild": "newton",
    "name": "Whoopee Cushion Seat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Newton's least popular invention, and somehow also his most requested.",
    "sheetClass": "vsheet-48",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-020",
    "guild": "newton",
    "name": "Failure Erasing Spray",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "One spray of this and it is like the failure never happened. But you get to keep the lessons learned!",
    "sheetClass": "vsheet-48",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-021",
    "guild": "newton",
    "name": "Bottomless Magical Toolbox",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "No matter how many tools you pull out, there always seems to be one more inside.",
    "sheetClass": "vsheet-49",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-022",
    "guild": "newton",
    "name": "Bounce Back Boomerang",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Always comes back, eventually, even when thrown really, really badly.",
    "sheetClass": "vsheet-49",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-023",
    "guild": "newton",
    "name": "Googly Eye Glasses",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Makes everything look a little more surprised than it actually is.",
    "sheetClass": "vsheet-49",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-024",
    "guild": "newton",
    "name": "Bubble Wrap Super Suit",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Padded head to toe, perfect for Newton's more ambitious and less carefully-planned experiments.",
    "sheetClass": "vsheet-49",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-025",
    "guild": "newton",
    "name": "Scrappy Underdog Jersey",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Faded, patched, and worn through more failed attempts than successful ones — which is exactly why Newton loves it.",
    "sheetClass": "vsheet-49",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-026",
    "guild": "newton",
    "name": "Airplane Blueprint",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Covered in crossed-out revisions, this blueprint represents at least a dozen failed attempts before the design finally worked.",
    "sheetClass": "vsheet-50",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-027",
    "guild": "newton",
    "name": "Indestructible Sand Castle",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Survived three storms, two accidental kicks, and one very determined seagull.",
    "sheetClass": "vsheet-50",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-028",
    "guild": "newton",
    "name": "Gecko Coin Bank",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shaped like a tiny gecko, this bank has been saving up for Newton's next big project for a while now.",
    "sheetClass": "vsheet-50",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-029",
    "guild": "newton",
    "name": "Enchanted First Aid Kit",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This kit doesn't heal scrapes any faster, but it makes putting the bandage on feel a lot less like giving up.",
    "sheetClass": "vsheet-50",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-030",
    "guild": "newton",
    "name": "Magic 8 Ball",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shake it and it mostly just tells you to try again — which, in Newton's workshop, is usually the right answer anyway.",
    "sheetClass": "vsheet-50",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-031",
    "guild": "newton",
    "name": "Rocket-Powered Roller Skates",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "An upgrade from the banana-peel version, these skates actually work — most of the time, and usually in the intended direction.",
    "sheetClass": "vsheet-51",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-032",
    "guild": "newton",
    "name": "Stubbed Toe Trophy",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Awarded, half-jokingly, for the most spectacular minor mishap in the workshop that week. Newton's won it more than once.",
    "sheetClass": "vsheet-51",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-033",
    "guild": "newton",
    "name": "Lucky Four Leaf Clover Goggles",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "See the world through these and every clover looks suspiciously four-leafed. Newton's not sure if that's magic or just wishful thinking.",
    "sheetClass": "vsheet-51",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-034",
    "guild": "newton",
    "name": "Breakfast of Champions",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Newton's face grins up from every bowl, a little embarrassing and a lot beloved around the workshop.",
    "sheetClass": "vsheet-51",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-035",
    "guild": "newton",
    "name": "Telepathic Helmet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Put this on and it doesn't read minds so much as loudly broadcast whatever you're already thinking — which is usually enough.",
    "sheetClass": "vsheet-51",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-036",
    "guild": "newton",
    "name": "Dented But Determined Lunch Box",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Dropped, sat on, and run over at least once, this lunchbox still keeps lunch fresh exactly like it did on day one.",
    "sheetClass": "vsheet-52",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-037",
    "guild": "newton",
    "name": "Mad Scientists Journal",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Full of crossed-out ideas and half-finished sketches, this journal is proof that even the best inventions start out looking like disasters.",
    "sheetClass": "vsheet-52",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-038",
    "guild": "newton",
    "name": "Patched Up Umbrella",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Held together with more tape than fabric at this point, but it's never once let a drop of rain through.",
    "sheetClass": "vsheet-52",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-039",
    "guild": "newton",
    "name": "Patchwork Quilt of Victories",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each patch on this quilt marks a small win that came after a much bigger failure. Newton adds a new one every few months.",
    "sheetClass": "vsheet-52",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-040",
    "guild": "newton",
    "name": "Lucky Rabbits Foot Key Chain",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Newton's not sure it actually brings luck, but he's never lost his workshop keys since he got it, so he's not taking chances.",
    "sheetClass": "vsheet-52",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-041",
    "guild": "newton",
    "name": "Bounce-Back Spring Boots",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Trip in these and you're back on your feet before you even hit the ground — usually. The occasional exception is part of the charm.",
    "sheetClass": "vsheet-53",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-042",
    "guild": "newton",
    "name": "Patched-Up Gecko Pillow",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Stitched, restuffed, and clearly loved a little too hard, this pillow has been through every rough draft in the workshop right alongside Newton.",
    "sheetClass": "vsheet-53",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-043",
    "guild": "newton",
    "name": "Big Boss Trading Card",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A rare card showing off Newton's proudest invention, back before three of its four legs fell off.",
    "sheetClass": "vsheet-53",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-044",
    "guild": "newton",
    "name": "Spring Loaded Confidence Boots",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each step comes with a tiny bounce, which Newton insists makes everything feel just a little more possible.",
    "sheetClass": "vsheet-53",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-045",
    "guild": "newton",
    "name": "Home made automobile",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Built from spare parts and a lot of hope, this little car actually runs — as long as you don't ask it to go uphill.",
    "sheetClass": "vsheet-53",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-046",
    "guild": "newton",
    "name": "Cardboard Helicopter",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Never actually left the ground, not once, but Newton keeps it on the shelf as a reminder of where every good idea starts.",
    "sheetClass": "vsheet-54",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-047",
    "guild": "newton",
    "name": "Duct-Taped Jetpack",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Newton's very first flying attempt, held together with more tape than metal. It only flies to the right but eventually gets you where you are trying to go.",
    "sheetClass": "vsheet-54",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-048",
    "guild": "newton",
    "name": "Rewired Antique Lamp",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Found flickering and forgotten in a junk pile, this lamp works perfectly now — Newton rewired it three separate times before it finally held a charge.",
    "sheetClass": "vsheet-54",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-049",
    "guild": "newton",
    "name": "Wish Granting Dandelion",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Blow on this dandelion and the seeds spell out, however briefly, whatever you're hoping for. Newton says it only works if you've already tried everything else first.",
    "sheetClass": "vsheet-54",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-050",
    "guild": "newton",
    "name": "Dragon Scale Shield",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Newton found all the individual scales while out scavenging in the forest. Newton calls it one of his most beautiful creations.",
    "sheetClass": "vsheet-54",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-051",
    "guild": "newton",
    "name": "Self Rebounding Basketball",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "No matter how badly you miss the shot, this basketball finds its way back to your hands. Newton built it after one too many afternoons chasing the ball into the bushes.",
    "sheetClass": "vsheet-55",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-052",
    "guild": "newton",
    "name": "Nine Lives Charm Bracelet",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Each charm on this bracelet marks a project Newton was sure had failed for good — until it didn't. There are nine charms. He's already planning the tenth.",
    "sheetClass": "vsheet-55",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-053",
    "guild": "newton",
    "name": "Gravity Defying Golden Apples",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "These apples hover just slightly above your palm instead of resting in it, a side effect of an experiment that didn't go quite as planned. Newton kept them anyway — happy accidents count too.",
    "sheetClass": "vsheet-55",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-054",
    "guild": "newton",
    "name": "Golden Underdog Statue",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A small statue of an unlikely winner, arms raised mid-celebration. Newton keeps it on his workbench for the days nothing seems to be working.",
    "sheetClass": "vsheet-55",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-055",
    "guild": "newton",
    "name": "Patched Hot Air Balloon",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This balloon has been patched so many times it's more patch than original fabric — and it still flies higher than anything Newton's built from scratch.",
    "sheetClass": "vsheet-55",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-056",
    "guild": "newton",
    "name": "Rebuilt junkyard Ferriswheel",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Salvaged from scrap and reassembled piece by piece, this tiny Ferris wheel still turns smoothly, powered by little more than stubbornness and a hand crank.",
    "sheetClass": "vsheet-56",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-057",
    "guild": "newton",
    "name": "Newton's Portrait",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This is Newton, goggles pushed up and covered in workshop grease, exactly as he looks mid-invention. He's rebuilt this portrait's frame at least three times — it kept falling off the wall.",
    "sheetClass": "vsheet-56",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-058",
    "guild": "newton",
    "name": "Repaired Battle Drum",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Cracked clean through and stitched back together with wire, this drum sounds even louder now than it did before it broke. Newton isn't sure why. He's not complaining either.",
    "sheetClass": "vsheet-56",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-059",
    "guild": "newton",
    "name": "Rainbow Gecko Egg",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This egg shimmers a new color every time the light hits it differently, and nobody in the workshop is entirely sure what's inside. Newton's still waiting to find out.",
    "sheetClass": "vsheet-56",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-060",
    "guild": "newton",
    "name": "Newton's Workshop Key",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This key doesn't just open the workshop door — it seems to know exactly which project Newton's stuck on before he even walks in. He's never lost it, which is honestly the real achievement.",
    "sheetClass": "vsheet-56",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-061",
    "guild": "newton",
    "name": "Magical Fix-It Wand",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Wave this wand over anything broken and it doesn't fix the problem exactly — it just makes the next attempt at fixing it a little easier. Newton says that's more useful anyway.",
    "sheetClass": "vsheet-57",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-062",
    "guild": "newton",
    "name": "Newton's Time Capsule",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Buried and dug back up more times than Newton can count, this time capsule holds notes from every failed invention he refused to give up on. He adds one more every year.",
    "sheetClass": "vsheet-57",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-063",
    "guild": "newton",
    "name": "Patched Up Dragon Egg",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Cracked clean through during an experiment gone sideways, this dragon egg was carefully glued back together — and somehow hatched anyway. Newton takes full credit for the second part.",
    "sheetClass": "vsheet-57",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-064",
    "guild": "newton",
    "name": "Wrestling Championship Belt",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Dented, scuffed, and missing one buckle, this belt has been won and lost and won back again more times than anyone in the workshop can count. Newton keeps it as proof that comebacks are always possible.",
    "sheetClass": "vsheet-57",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-065",
    "guild": "newton",
    "name": "Sunken Ship Bell",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Pulled from a wreck nobody thought was salvageable, this bell still rings true once the rust was cleared away. Newton spent three weekends on it.",
    "sheetClass": "vsheet-57",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-066",
    "guild": "newton",
    "name": "Self Bailing Sail Boat",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This little boat pumps water back out automatically the moment it starts taking any on, a fix Newton came up with after sinking the first four versions.",
    "sheetClass": "vsheet-58",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-067",
    "guild": "newton",
    "name": "Everlasting Second Wind",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Bottled from the exact feeling of getting back up after a rough fall, this relic doesn't do much — it just reminds you that you've still got more in you. Newton keeps his close.",
    "sheetClass": "vsheet-58",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-068",
    "guild": "newton",
    "name": "Golden Kintsugi Pottery",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Shattered once, long ago, and repaired with real gold in every crack, this pottery is considered more beautiful broken and mended than it ever was whole. Newton keeps it exactly where anyone can see it.",
    "sheetClass": "vsheet-58",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-069",
    "guild": "newton",
    "name": "Thousand Attempts Trophy",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Awarded for exactly what it sounds like — a thousand tries at something that finally, eventually, worked. Newton's own trophy shelf has three of these, and he's not stopping.",
    "sheetClass": "vsheet-58",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-070",
    "guild": "newton",
    "name": "Comeback Crown",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Worn only by someone who's failed spectacularly and come back stronger anyway, this crown has been passed around the workshop more than once. Newton's held onto it the longest.",
    "sheetClass": "vsheet-58",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PER-071",
    "guild": "newton",
    "name": "Newtons Monument of Many Failures",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "A small statue covered in tiny plaques, each one marking an invention that didn't work — until, eventually, one did. Newton says it's his favorite piece in the whole workshop.",
    "sheetClass": "vsheet-59",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PER-072",
    "guild": "newton",
    "name": "Restored Celestial Stain Glass Window",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Shattered in a storm and painstakingly reassembled piece by piece, this window now catches the light even more beautifully than before it broke. Newton spent an entire winter on the repair.",
    "sheetClass": "vsheet-59",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PER-073",
    "guild": "newton",
    "name": "Newt's Founder Flag",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This flag has been patched, re-stitched, and taped back together more times than anyone can count — which is exactly why it still flies over Newton's workshop today.",
    "sheetClass": "vsheet-59",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PER-074",
    "guild": "newton",
    "name": "The First Flying Machine",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Newton's very first invention, and also his very first failure — it took forty-two tries before it finally got off the ground. He keeps it exactly as it looked on try number forty-three.",
    "sheetClass": "vsheet-59",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PER-075",
    "guild": "newton",
    "name": "Indestructible Chess King",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Dropped, cracked, glued, and dropped again more times than Newton can count, this chess piece has never once been knocked out of the game. It's less a trophy and more proof that giving up was never an option.",
    "sheetClass": "vsheet-59",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-001",
    "guild": "quik",
    "name": "Explorer's Compass",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Never quite agrees with magnetic north, but always seems to point toward the most interesting direction anyway.",
    "sheetClass": "vsheet-60",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-002",
    "guild": "quik",
    "name": "Adventurer's Backpack",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn in all the right places from real trail use, this backpack has carried more snacks than survival gear, honestly.",
    "sheetClass": "vsheet-60",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-003",
    "guild": "quik",
    "name": "Quik's Sleeping Bag",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Quik made sure this sleeping bag was as warm as his fur. It smells faintly of campfire smoke and has seen more nights outdoors than most tents.",
    "sheetClass": "vsheet-60",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-004",
    "guild": "quik",
    "name": "Illuminating Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns a soft, steady glow that never seems to flicker, no matter how windy the trail gets.",
    "sheetClass": "vsheet-60",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-005",
    "guild": "quik",
    "name": "Traveler's Journal",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Half the pages are full of sketches, the other half full of notes nobody but the writer can read.",
    "sheetClass": "vsheet-60",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-006",
    "guild": "quik",
    "name": "Wooden Walking Stick",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn smooth from years of gripping, this staff has steadied more than a few tricky river crossings.",
    "sheetClass": "vsheet-61",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-007",
    "guild": "quik",
    "name": "Spider Web Climbing Rope",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Stronger than it looks and surprisingly light to carry, this rope has never once frayed on a climb.",
    "sheetClass": "vsheet-61",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-008",
    "guild": "quik",
    "name": "Enchanted Pocket Map",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Folds down small enough to fit in any pocket, and somehow always unfolds to show exactly the part of the trail you need.",
    "sheetClass": "vsheet-61",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-009",
    "guild": "quik",
    "name": "Mythic Marshmallow stick",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Toasts a marshmallow to golden perfection every single time — never burnt, never raw.",
    "sheetClass": "vsheet-61",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-010",
    "guild": "quik",
    "name": "Pet Rock",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Doesn't do much, but it's been on every single trip so far and nobody's willing to leave it behind now.",
    "sheetClass": "vsheet-61",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-011",
    "guild": "quik",
    "name": "Lucky Acorn",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Found on the very first trail ever explored, this acorn's been carried in a pocket ever since, for luck.",
    "sheetClass": "vsheet-62",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-012",
    "guild": "quik",
    "name": "Enchanted Forest Feather",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Drifted down from somewhere too high to see, this feather seems to hold some magical power that keeps travelers safe on their journey.",
    "sheetClass": "vsheet-62",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-013",
    "guild": "quik",
    "name": "Trail Juice Box",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Small, sweet, and always ice-cold no matter how hot the trail gets. Nobody knows how.",
    "sheetClass": "vsheet-62",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-014",
    "guild": "quik",
    "name": "Unicorn Floaty",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Perfect for river crossings, or just floating lazily downstream on a slow day.",
    "sheetClass": "vsheet-62",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-015",
    "guild": "quik",
    "name": "Frog Rain Boots",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bright green and surprisingly good at keeping feet dry through the muddiest stretches of trail.",
    "sheetClass": "vsheet-62",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-016",
    "guild": "quik",
    "name": "Flower Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Woven fresh from trailside blooms, this hat never wilts because it is crafted with enchanted daisies.",
    "sheetClass": "vsheet-63",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-017",
    "guild": "quik",
    "name": "Yeti Slippers",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Warm, oversized, and completely impractical for actual hiking — which is exactly why they're perfect for camp at night.",
    "sheetClass": "vsheet-63",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-018",
    "guild": "quik",
    "name": "Flower Satchel",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Small enough to carry easily, and always smells faintly of whatever flowers grew nearby when it was packed.",
    "sheetClass": "vsheet-63",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-019",
    "guild": "quik",
    "name": "Adventure Mushroom Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Wide-brimmed and surprisingly good at keeping the sun off, even if it does look a little silly.",
    "sheetClass": "vsheet-63",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-020",
    "guild": "quik",
    "name": "Pocket Campfire",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Small enough to carry, warm enough to actually matter on a cold night on the trail.",
    "sheetClass": "vsheet-63",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-021",
    "guild": "quik",
    "name": "Corn Cob Flashlight",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows a warm yellow light, bright enough to read a trail map by after dark.",
    "sheetClass": "vsheet-64",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-022",
    "guild": "quik",
    "name": "Academy Passport",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Stamped once for every world explored, this little booklet is nearly full.",
    "sheetClass": "vsheet-64",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-023",
    "guild": "quik",
    "name": "Cricket Alarm Clock",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Chirps insistently at exactly the same time every morning, whether anyone's ready to wake up or not.",
    "sheetClass": "vsheet-64",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-024",
    "guild": "quik",
    "name": "Lucky Smelly Sock",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Nobody's quite sure why it's lucky, but it's been worn on every important trip since it was found.",
    "sheetClass": "vsheet-64",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-025",
    "guild": "quik",
    "name": "Portable Dog House",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Collapses down to nearly nothing and pops right back up when it's needed — handy for any four-legged trail companions.",
    "sheetClass": "vsheet-64",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-026",
    "guild": "quik",
    "name": "Magic Drinking Straw",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Somehow makes even plain trail water taste a little sweeter. Quik swears by it.",
    "sheetClass": "vsheet-65",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-027",
    "guild": "quik",
    "name": "Adventure Jetpack",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sputters more than it flies, but on a good day it'll get you over a particularly stubborn hill.",
    "sheetClass": "vsheet-65",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-028",
    "guild": "quik",
    "name": "Emergency Enchanted Toilet Paper",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Never runs out mid-use — possibly the most quietly appreciated relic on the entire trail.",
    "sheetClass": "vsheet-65",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-029",
    "guild": "quik",
    "name": "Watermelon Backpack",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Hollowed out and surprisingly roomy, this watermelon backpack somehow never goes bad no matter how long it's carried.",
    "sheetClass": "vsheet-65",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-030",
    "guild": "quik",
    "name": "Invisibility Cloak",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Wrap yourself in this cloak and you will completely vanish. Quik uses it to sneak past grumpy trail wildlife.",
    "sheetClass": "vsheet-65",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-031",
    "guild": "quik",
    "name": "Banana Compass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "The peel points north no matter which way you twist it, which makes it either the most useless or most reliable compass on the trail, depending who you ask.",
    "sheetClass": "vsheet-66",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-032",
    "guild": "quik",
    "name": "Firefly Bottle",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Capture a few fireflies in this jar and you've got a soft glowing lantern that never needs batteries — just the occasional gentle release back into the woods.",
    "sheetClass": "vsheet-66",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-033",
    "guild": "quik",
    "name": "Quik Portrait",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This is Quik himself, always ready for whatever trail comes next. This portrait hung on his home wall for as long as he can remember. Now he has entrusted you with it, so put it somewhere special.",
    "sheetClass": "vsheet-66",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-034",
    "guild": "quik",
    "name": "Time Traveling Hourglass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Turn this hourglass over and, for exactly one minute, it feels like time slows down just enough to catch your breath.",
    "sheetClass": "vsheet-66",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-035",
    "guild": "quik",
    "name": "Instant Tent",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Toss this bundle on the ground and it pops into a full tent in seconds — folding back down just as fast when it's time to move on.",
    "sheetClass": "vsheet-66",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-036",
    "guild": "quik",
    "name": "Toadstool",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Big enough to sit on and soft enough to nap on, this oversized toadstool has saved more than one tired traveler's feet.",
    "sheetClass": "vsheet-67",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-037",
    "guild": "quik",
    "name": "Caterpillar Hammock",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Strung between two trees, this hammock is somehow always the exact right length no matter the distance. Nobody's figured out how.",
    "sheetClass": "vsheet-67",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-038",
    "guild": "quik",
    "name": "Cactus Water Bottle",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shaped like a cactus and somehow always cool to the touch, this bottle keeps water fresh even on the hottest stretch of trail.",
    "sheetClass": "vsheet-67",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-039",
    "guild": "quik",
    "name": "Endless Backpack",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "No matter how much you pack, there's always a little more room inside. Quik still hasn't found the bottom.",
    "sheetClass": "vsheet-67",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-040",
    "guild": "quik",
    "name": "Marshmallow Launcher",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Built for campfire mishaps, this little launcher sends a marshmallow flying straight into the fire — perfectly toasted, most of the time.",
    "sheetClass": "vsheet-67",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-041",
    "guild": "quik",
    "name": "Enchanted Explorer's Pocket Watch",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This watch doesn't tell the time so much as the mood of the trail ahead — ticking faster when there's adventure coming.",
    "sheetClass": "vsheet-68",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-042",
    "guild": "quik",
    "name": "Wooden Rain Stick",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Turn it over on the hottest days and rain will immediately start to fall. Comes in handy when you need a little break from the heat.",
    "sheetClass": "vsheet-68",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-043",
    "guild": "quik",
    "name": "Fortune Telling Crystal Ball",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Peer into this crystal ball and it shows you, vaguely, whether the trail ahead gets easier or harder. It's right about half the time.",
    "sheetClass": "vsheet-68",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-044",
    "guild": "quik",
    "name": "Squirrel Proof Snack Bag",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Nothing gets past this bag's clever little clasp — not even the most determined trailside squirrel, and there have been some very determined squirrels.",
    "sheetClass": "vsheet-68",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-045",
    "guild": "quik",
    "name": "Bear Spray",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Never actually used on a bear, as far as anyone knows, but Quik carries it anyway. Better safe than sorry.",
    "sheetClass": "vsheet-68",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-046",
    "guild": "quik",
    "name": "fortune tellers spy glass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Look through this spyglass and it seems to focus a little too well on whatever you're most curious about, trail-wise or otherwise.",
    "sheetClass": "vsheet-69",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-047",
    "guild": "quik",
    "name": "Acorn Slingshot",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Quik whittled this out of a fallen branch after one too many squirrels stole his snacks. It's not much to look at, but it's surprisingly accurate.",
    "sheetClass": "vsheet-69",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-048",
    "guild": "quik",
    "name": "Crystal Climbing Axe",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from a single shard of trailside quartz, this axe never dulls no matter how many cliffs it climbs. Quik only pulls it out for the steepest parts of the trail.",
    "sheetClass": "vsheet-69",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-049",
    "guild": "quik",
    "name": "Dinosaur Bone Walking Stick",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Dug up half-buried near an old riverbed, this walking stick is older than anyone can guess. It clicks against stone with a sound like distant thunder.",
    "sheetClass": "vsheet-69",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-050",
    "guild": "quik",
    "name": "Crystal Trail Boots",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "These boots crunch like fresh snow with every step, even on dry dirt trails. Quik swears they've never once given him a blister.",
    "sheetClass": "vsheet-69",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-051",
    "guild": "quik",
    "name": "Inflatable dragon Pillow",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Perfect for a nap halfway up the mountain, this pillow puffs up in seconds and deflates just as fast. Quik keeps one rolled tight in the bottom of his pack.",
    "sheetClass": "vsheet-70",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-052",
    "guild": "quik",
    "name": "Bug Eye Goggles",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "These goggles let you see every leaf, pebble, and hidden trail marker in incredible detail. Quik uses them to spot shortcuts nobody else notices.",
    "sheetClass": "vsheet-70",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-053",
    "guild": "quik",
    "name": "Ancient Pathfinder Map",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Drawn by an explorer who mapped trails nobody else dared to walk, this map still leads true many generations later. Quik keeps it rolled in oilskin to protect what's left.",
    "sheetClass": "vsheet-70",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-054",
    "guild": "quik",
    "name": "Lucky Fishing Pole",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This pole has never once come back from the river empty, according to Quik — though nobody's actually counted. It bends just right when something's about to bite.",
    "sheetClass": "vsheet-70",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-055",
    "guild": "quik",
    "name": "Quik Founders Flag",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This flag marks the very first trail Quik ever blazed for the Explorer Guild. Every badge, every relic, every adventure in this guild traces back to the spot where it was planted.",
    "sheetClass": "vsheet-70",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-056",
    "guild": "quik",
    "name": "Strawberry First Aid Kit",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This kit pops open to reveal bandages, medications, potions and just enough courage to keep walking. Quik never sets out on a long trail without it.",
    "sheetClass": "vsheet-71",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-057",
    "guild": "quik",
    "name": "Golden Forest Bow & Arrow",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Strung with vine and tipped in gold, this bow was carved from the oldest tree on the trail. Quik only uses it for the most important shots.",
    "sheetClass": "vsheet-71",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-058",
    "guild": "quik",
    "name": "Mythic Butterfly Net",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This net has caught butterflies that don't appear in any field guide — wings that shimmer colors nobody can quite name. Quik always lets them go again after a look.",
    "sheetClass": "vsheet-71",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-059",
    "guild": "quik",
    "name": "Mushroom Umbrella",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Grown, not built, this giant mushroom cap keeps off rain better than anything store-bought. Quik found it sprouting beside the trail after a storm and never looked back.",
    "sheetClass": "vsheet-71",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-060",
    "guild": "quik",
    "name": "Explorers Crown",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Woven from vines and dotted with precious mountain jewels, this crown is only ever worn by whoever's explored the most territory that season. Quik has worn it exactly twice.",
    "sheetClass": "vsheet-71",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-061",
    "guild": "quik",
    "name": "Dragon Ruby Necklace",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Each ruby on this necklace was pried loose from a sleeping dragon's hoard, one gem at a time, without ever waking it up. Quik still isn't sure how he pulled that off.",
    "sheetClass": "vsheet-72",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-062",
    "guild": "quik",
    "name": "Magic Forest Potion",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "One sip of this potion and the whole forest seems to whisper directions, pointing you toward whatever you're looking for. Quik only drinks it when he's truly, hopelessly lost.",
    "sheetClass": "vsheet-72",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-063",
    "guild": "quik",
    "name": "Golden Money Tree",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This tiny tree grows real gold coins instead of leaves. Quik checks it every morning to fill up his wallet. Mostly so he can buy snacks along his journey.",
    "sheetClass": "vsheet-72",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-064",
    "guild": "quik",
    "name": "Glowing River Canoe",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Paddle this canoe after dark and the whole hull lights up, tracing a soft glow across the water. Quik uses it for the trickiest night crossings on the trail.",
    "sheetClass": "vsheet-72",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-065",
    "guild": "quik",
    "name": "Volcanic Magic Wand",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Warm to the touch and faintly smoking at the tip, this wand was carved from stone pulled straight from an active volcano. Quik keeps it wrapped in thick cloth, just in case.",
    "sheetClass": "vsheet-72",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-066",
    "guild": "quik",
    "name": "Dragon Bone Grappling Hook",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from a bone too large to have come from anything but a dragon, this hook has never once slipped its grip on a cliff face. Quik trusts it with his life, literally.",
    "sheetClass": "vsheet-73",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-067",
    "guild": "quik",
    "name": "Treasure Attracting Magnet",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Point this magnet in any direction and it tugs gently toward the nearest hidden treasure, though it's just as likely to lead you to a lost button as gold. Quik follows it anyway. You never know.",
    "sheetClass": "vsheet-73",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-068",
    "guild": "quik",
    "name": "Frozen Lightning Bolt Sword",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Struck from lightning captured mid-strike and frozen solid before it could fade, this sword still crackles faintly along its edge. Quik's only drawn it twice, both times during real emergencies.",
    "sheetClass": "vsheet-73",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-069",
    "guild": "quik",
    "name": "Shooting Star in a Jar",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Caught the instant it streaked across the sky, this star still glows faintly inside its jar, dimming just slightly more each year. Quik says he's saving his wish for something important.",
    "sheetClass": "vsheet-73",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-070",
    "guild": "quik",
    "name": "Forest Fairy Wings",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Left behind by a fairy who outgrew them, these wings still shimmer faintly and occasionally flutter on their own. Quik keeps them somewhere safe, just in case their owner ever comes looking.",
    "sheetClass": "vsheet-73",
    "bgPos": "-160px -160px"
  },
  {
    "id": "PRO-071",
    "guild": "quik",
    "name": "Holographic Moon Lamp",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This lamp projects the moon in perfect, shifting detail, cycling slowly through every phase over the course of a month. Quik uses it to navigate the trail at night.",
    "sheetClass": "vsheet-74",
    "bgPos": "-0px -0px"
  },
  {
    "id": "PRO-072",
    "guild": "quik",
    "name": "Forest Dragon Egg",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Nested deep in the oldest part of the forest, this egg has never once cracked, hatched, or even changed temperature. Quik checks on it every trip, just to be sure it's still there.",
    "sheetClass": "vsheet-74",
    "bgPos": "-160px -0px"
  },
  {
    "id": "PRO-073",
    "guild": "quik",
    "name": "Dinosaur Fossil",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Unearthed from a riverbank after a storm washed away years of dirt, this fossil is older than anything else in the Explorer Guild's collection. Quik still isn't sure what kind of dinosaur it belonged to.",
    "sheetClass": "vsheet-74",
    "bgPos": "-320px -0px"
  },
  {
    "id": "PRO-074",
    "guild": "quik",
    "name": "Magical Transporting Door",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Step through this door and you could end up anywhere the forest trail leads — nobody, not even Quik, knows exactly where it opens next. It's the most unpredictable relic in the entire Explorer Guild.",
    "sheetClass": "vsheet-74",
    "bgPos": "-0px -160px"
  },
  {
    "id": "PRO-075",
    "guild": "quik",
    "name": "Forest King Throne",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Carved from the oldest tree at the heart of the forest, this throne is said to seat whoever has explored more of the world than anyone else. Quik himself has only sat in it once.",
    "sheetClass": "vsheet-74",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-001",
    "guild": "ace",
    "name": "Smart Cookie",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Eat one before a big test and you'll swear you feel a little sharper. Ace insists it's just the sugar.",
    "sheetClass": "vsheet-75",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-002",
    "guild": "ace",
    "name": "Homework Pizza",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sliced into exactly the right number of pieces for a study group, every single time.",
    "sheetClass": "vsheet-75",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-003",
    "guild": "ace",
    "name": "Spare Brain",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Kept in the library 'just in case,' though nobody's ever actually needed to use it.",
    "sheetClass": "vsheet-75",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-004",
    "guild": "ace",
    "name": "Cliffhanger Book",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Ends on such a dramatic note that it's nearly impossible to put down before finishing.",
    "sheetClass": "vsheet-75",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-005",
    "guild": "ace",
    "name": "Chameleon Crayon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Changes color depending on what it's drawing, which makes for some very unpredictable artwork.",
    "sheetClass": "vsheet-75",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-006",
    "guild": "ace",
    "name": "Magic Marker",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Anything drawn with this marker comes to life. Ace uses it carefully, some of his drawings are really bad.",
    "sheetClass": "vsheet-76",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-007",
    "guild": "ace",
    "name": "Inch Worm Ruler",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Measures things perfectly, as long as it's less than 12 inches.",
    "sheetClass": "vsheet-76",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-008",
    "guild": "ace",
    "name": "Memory Eraser",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Doesn't erase memories — just erases the mistake right underneath it, cleanly, every time.",
    "sheetClass": "vsheet-76",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-009",
    "guild": "ace",
    "name": "Bubble Typewriter",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Each key press pops a tiny bubble instead of making a click, which makes typing oddly satisfying.",
    "sheetClass": "vsheet-76",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-010",
    "guild": "ace",
    "name": "Moonbeam Magnifying Glass",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Makes small text easy to read even in dim light, thanks to a faint glow built right into the lens.",
    "sheetClass": "vsheet-76",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-011",
    "guild": "ace",
    "name": "Solar System Diagram",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Each planet spins slowly on its own tiny orbit, perfectly to scale except for being much, much smaller.",
    "sheetClass": "vsheet-77",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-012",
    "guild": "ace",
    "name": "Hot Air Balloon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small classroom model that actually rises a few inches off the desk when the little burner's lit.",
    "sheetClass": "vsheet-77",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-013",
    "guild": "ace",
    "name": "Runaway Paperclips",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "These paperclips seem to wander off the desk on their own, only to turn up again a week later.",
    "sheetClass": "vsheet-77",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-014",
    "guild": "ace",
    "name": "Curiosity Cardboard Box",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "An empty box that somehow ends up being the most-played-with item in the whole classroom.",
    "sheetClass": "vsheet-77",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-015",
    "guild": "ace",
    "name": "Book Bag",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn at the seams from years of overstuffing, this bag has carried more books than it was ever designed to.",
    "sheetClass": "vsheet-77",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-016",
    "guild": "ace",
    "name": "Pop Quiz Popcorn",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Pops with a satisfying crunch right when you least expect it — much like an actual pop quiz.",
    "sheetClass": "vsheet-78",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-017",
    "guild": "ace",
    "name": "Shark Pencil Sharpener",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sharpens a pencil to a perfect point in one satisfying crank of its little shark-jaw handle.",
    "sheetClass": "vsheet-78",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-018",
    "guild": "ace",
    "name": "Sleepy Sloth Study Slippers",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Slow, soft, and perfect for long study sessions curled up on the couch.",
    "sheetClass": "vsheet-78",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-019",
    "guild": "ace",
    "name": "Study Break Waffle Iron",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Makes a perfectly golden waffle in exactly the time it takes to finish one more page.",
    "sheetClass": "vsheet-78",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-020",
    "guild": "ace",
    "name": "Wishbone Pen",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shaped like a wishbone, this pen is said to write a little more clearly when you're hoping for good news.",
    "sheetClass": "vsheet-78",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-021",
    "guild": "ace",
    "name": "Dinosaur Desk",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shaped like a friendly dinosaur, this desk has a spot for every pencil, book, and stray eraser.",
    "sheetClass": "vsheet-79",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-022",
    "guild": "ace",
    "name": "Foxy Bookmark",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Clips neatly onto any page and never once slips out, even from the thickest books.",
    "sheetClass": "vsheet-79",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-023",
    "guild": "ace",
    "name": "Magical Illuminating Highlighter",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Highlights exactly the part of the page you'll actually need to remember later — most of the time.",
    "sheetClass": "vsheet-79",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-024",
    "guild": "ace",
    "name": "Lucky Library Ladder",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Always seems to be exactly tall enough to reach whatever book you're looking for, no matter the shelf.",
    "sheetClass": "vsheet-79",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-025",
    "guild": "ace",
    "name": "Alphabet Cereal",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Spells out little words in the bowl before you can eat them, which makes breakfast take a lot longer.",
    "sheetClass": "vsheet-79",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-026",
    "guild": "ace",
    "name": "Sticky Note Launcher",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Fires a sticky note clean across the room and it somehow always lands exactly where it's supposed to stick.",
    "sheetClass": "vsheet-80",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-027",
    "guild": "ace",
    "name": "Magic Label Maker",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Prints labels in perfectly neat handwriting, even when the person using it has terrible handwriting themselves.",
    "sheetClass": "vsheet-80",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-028",
    "guild": "ace",
    "name": "Book Keepers Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Lights the library's quietest corner every evening, right up until closing time.",
    "sheetClass": "vsheet-80",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-029",
    "guild": "ace",
    "name": "Report Card Repair Kit",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "For the roughest grades. It gives you a second chance to learn and repair your grade.",
    "sheetClass": "vsheet-80",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-030",
    "guild": "ace",
    "name": "Rainbow Eraser",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Erase a mistake with this and the eraser leaves the faintest rainbow smudge behind, like it's celebrating the fix.",
    "sheetClass": "vsheet-80",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-031",
    "guild": "ace",
    "name": "Invisible Ink Pen",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Write with this pen and the words only appear once you actually understand what you wrote — which makes cheating with it pretty pointless.",
    "sheetClass": "vsheet-81",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-032",
    "guild": "ace",
    "name": "Never-Ending Bendy Pencil",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This pencil bends into almost any shape without snapping, and somehow never seems to run out of lead.",
    "sheetClass": "vsheet-81",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-033",
    "guild": "ace",
    "name": "Smarty Pants",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Put these on and you'll swear you feel just a little sharper — though Ace admits that might just be confidence.",
    "sheetClass": "vsheet-81",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-034",
    "guild": "ace",
    "name": "Magic Encyclopedia",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Ask this encyclopedia a question out loud and the right page tends to fall open on its own. Usually.",
    "sheetClass": "vsheet-81",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-035",
    "guild": "ace",
    "name": "Peacock Feather Pen",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Writes in shifting, iridescent ink that catches the light differently depending on the angle you're reading from.",
    "sheetClass": "vsheet-81",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-036",
    "guild": "ace",
    "name": "Braincell Battery",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Pop this battery in anything and it doesn't power the device so much as power your focus. Ace swears by it during exam week.",
    "sheetClass": "vsheet-82",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-037",
    "guild": "ace",
    "name": "Magical Pop Up Book",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Open any page and the scene folds up into a tiny 3D diorama, accurate right down to the smallest detail.",
    "sheetClass": "vsheet-82",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-038",
    "guild": "ace",
    "name": "Genius Goggles",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Wear these and complicated diagrams suddenly seem to make a lot more sense. Ace insists it's the goggles. Others suspect it's just paying closer attention.",
    "sheetClass": "vsheet-82",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-039",
    "guild": "ace",
    "name": "Powernap Pillow",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A ten-minute nap on this pillow feels like a full night's sleep — though the effect wears off disappointingly fast.",
    "sheetClass": "vsheet-82",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-040",
    "guild": "ace",
    "name": "Brainstorm Helmet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Put this on when you're stuck and ideas start arriving noticeably faster, if a little more chaotically than usual.",
    "sheetClass": "vsheet-82",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-041",
    "guild": "ace",
    "name": "Einstein's Mustache Case",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This little case is said to have once held a mustache belonging to history's most famous genius. Ace has never opened it, out of respect.",
    "sheetClass": "vsheet-83",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-042",
    "guild": "ace",
    "name": "Brain Freeze Smoothie",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Drink this too fast and you'll regret it immediately — but somehow you'll remember whatever you were studying a lot better afterward.",
    "sheetClass": "vsheet-83",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-043",
    "guild": "ace",
    "name": "Lion's Mane Thinking Cap",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Bushy, a little silly-looking, and surprisingly effective at helping the wearer think through a tough problem out loud.",
    "sheetClass": "vsheet-83",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-044",
    "guild": "ace",
    "name": "Magical Floating Globe",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This globe hovers a few inches above its stand, slowly spinning on its own, no matter how still the room is.",
    "sheetClass": "vsheet-83",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-045",
    "guild": "ace",
    "name": "Ace Portrait",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This is Ace, glasses on and book in hand, caught mid-thought the way he always looks in the Scholar's Guild library. It's an early pickup for most collectors, but a proud one all the same.",
    "sheetClass": "vsheet-83",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-046",
    "guild": "ace",
    "name": "Oops Button",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Press this after a mistake and it doesn't undo anything — it just makes the mistake feel a little less permanent.",
    "sheetClass": "vsheet-84",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-047",
    "guild": "ace",
    "name": "Mirror of Memories",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Look into this mirror and it shows you the exact moment you finally understood something that used to confuse you. Ace keeps his propped on the desk for bad days.",
    "sheetClass": "vsheet-84",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-048",
    "guild": "ace",
    "name": "Orb of Ideas",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Hold this orb while you're stuck on a problem and it hums faintly louder the closer you get to the answer. It's never actually solved anything — it just refuses to let you give up.",
    "sheetClass": "vsheet-84",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-049",
    "guild": "ace",
    "name": "Living Origami Dragon",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Folded from a single sheet of enchanted paper, this tiny dragon flaps its wings and occasionally breathes a puff of glitter instead of fire. It never unfolds itself, no matter how many times it's dropped.",
    "sheetClass": "vsheet-84",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-050",
    "guild": "ace",
    "name": "Treasure Encyclopedia",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Every page of this encyclopedia is a little heavier than it should be, as though real treasure were somehow bound between the covers. Nobody's found any gold yet, just really good information.",
    "sheetClass": "vsheet-84",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-051",
    "guild": "ace",
    "name": "Grammar Wizard Hat",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Wear this hat and every sentence that comes out of your mouth is suddenly, mysteriously, perfectly punctuated. Ace insists it doesn't work on essays. He's tried.",
    "sheetClass": "vsheet-85",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-052",
    "guild": "ace",
    "name": "The Last Puzzle Piece",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This single puzzle piece doesn't belong to any puzzle anyone's ever found — but it fits perfectly into the empty space on every collector's shelf. Nobody knows where the rest of the puzzle went.",
    "sheetClass": "vsheet-85",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-053",
    "guild": "ace",
    "name": "Ace Founder Flag",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This flag marked the very first quiz Ace ever aced — the moment the Scholar's Guild truly began. It's been kept safe in the library ever since.",
    "sheetClass": "vsheet-85",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-054",
    "guild": "ace",
    "name": "Lightning in a Bottle",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A single bolt of lightning, caught mid-strike and sealed in glass, still crackles faintly if you shake it. Ace keeps his on the highest shelf, just in case.",
    "sheetClass": "vsheet-85",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-055",
    "guild": "ace",
    "name": "Cosmic Comic Book",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The panels in this comic book rearrange themselves slightly every time you open it, as though the story is still being written. Nobody's ever managed to read it the same way twice.",
    "sheetClass": "vsheet-85",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-056",
    "guild": "ace",
    "name": "Map of Constellations",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Every star on this map is labeled in Ace's own handwriting, connected by lines only he seems able to make sense of. He says it's a map of the sky. Some say it's a map of something else.",
    "sheetClass": "vsheet-86",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-057",
    "guild": "ace",
    "name": "Shakespeare's Journal",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Pages of half-finished sonnets and crossed-out lines fill this journal, as though even the greatest writers needed a rough draft. Ace reads a page whenever he's stuck on his own writing.",
    "sheetClass": "vsheet-86",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-058",
    "guild": "ace",
    "name": "Book Worm Award",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Given only to readers who finish an entire shelf without stopping, this little trophy is shaped like a bookworm curled up mid-page. It's smaller than most trophies, and Ace is prouder of it than almost anything else.",
    "sheetClass": "vsheet-86",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-059",
    "guild": "ace",
    "name": "Eternal Reading Candle",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This candle never burns down, no matter how many all-night reading sessions it survives. Ace has had the same one lit on his desk for as long as anyone can remember.",
    "sheetClass": "vsheet-86",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-060",
    "guild": "ace",
    "name": "Crystal Galaxy Fox Head",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from a single piece of crystal shot through with tiny points of light, this fox head sculpture looks like it's holding an entire galaxy inside. Ace keeps it on his highest shelf.",
    "sheetClass": "vsheet-86",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-061",
    "guild": "ace",
    "name": "Librarian's Magical Wand",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This wand doesn't cast spells so much as find books — point it anywhere in the library and it drifts toward exactly what you're looking for. Ace borrowed it once and never quite gave it back.",
    "sheetClass": "vsheet-87",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-062",
    "guild": "ace",
    "name": "Viper Venom",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Sealed in a tiny vial and used, very carefully, in the Scholar's Guild's most advanced lessons, this venom is more valuable for what it teaches than what it does. Ace keeps his locked away.",
    "sheetClass": "vsheet-87",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-063",
    "guild": "ace",
    "name": "Magical Dreamcatcher",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Hung above a reading nook, this dreamcatcher is said to catch confusing thoughts before they turn into bad dreams. Ace swears his studying improved the week he hung it up.",
    "sheetClass": "vsheet-87",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-064",
    "guild": "ace",
    "name": "Graduate Hat",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Tossed in the air only once, at the end of the hardest lesson anyone's ever finished, this cap has a permanent crease from landing the same way every time. Ace keeps his in a place of honor.",
    "sheetClass": "vsheet-87",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-065",
    "guild": "ace",
    "name": "Library Dragon Egg",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Nobody's quite sure how a dragon egg ended up in the Scholar's Guild library, but it's been sitting on the same shelf, warm and unbothered, for years. Ace checks on it more than he'll admit.",
    "sheetClass": "vsheet-87",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-066",
    "guild": "ace",
    "name": "Dragon Saphire Bracelet",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Each sapphire on this bracelet came from a different dragon's hoard, collected one careful negotiation at a time. Ace says the dragons were surprisingly reasonable, for dragons.",
    "sheetClass": "vsheet-88",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-067",
    "guild": "ace",
    "name": "Moonlight Library Lantern",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This lantern only lights up after dark, casting a soft blue glow perfect for reading long after the library's officially closed. Ace has been caught under it more than once.",
    "sheetClass": "vsheet-88",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-068",
    "guild": "ace",
    "name": "Golden Library Card",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This card never expires and grants access to sections of the Scholar's Guild library that most collectors don't even know exist. Ace has had his since the very beginning.",
    "sheetClass": "vsheet-88",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-069",
    "guild": "ace",
    "name": "Golden Rosetta Stone",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "A perfect golden replica of the stone that once unlocked an entire lost language, kept in the Scholar's Guild as a reminder that any mystery can be solved with enough patience.",
    "sheetClass": "vsheet-88",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-070",
    "guild": "ace",
    "name": "The Authors Throne",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Reserved for whoever's finished the most books in a single season, this throne is more comfortable than it looks — good, since the best readers tend to sit a while.",
    "sheetClass": "vsheet-88",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SCH-071",
    "guild": "ace",
    "name": "Glowing Meteor",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Pulled from where it landed just outside the library, this meteor still glows faintly warm, as though it hasn't quite finished falling. Ace studies it more than he studies most textbooks.",
    "sheetClass": "vsheet-89",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SCH-072",
    "guild": "ace",
    "name": "Professor's Spellbook",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Every page adds a new spell the moment the reader actually understands the lesson behind it — which means most of this book is still frustratingly blank. Ace is working on it.",
    "sheetClass": "vsheet-89",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SCH-073",
    "guild": "ace",
    "name": "Infinite Golden Hall Pass",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This pass never runs out of uses and opens doors in the Scholar's Guild library that stay locked to everyone else. Ace has never actually needed to use it. He just likes having it.",
    "sheetClass": "vsheet-89",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SCH-074",
    "guild": "ace",
    "name": "The Infinity Diamond",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "A diamond with no visible end, said to hold every fact ever learned inside it. Ace has spent years trying to read what's written at its center and still hasn't reached the bottom.",
    "sheetClass": "vsheet-89",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SCH-075",
    "guild": "ace",
    "name": "Holy Grail of Knowledge",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "The single most prized object in the entire Scholar's Guild library, rumored to answer any question asked of it — if you can find where it's hidden. Ace has looked. He still hasn't found it.",
    "sheetClass": "vsheet-89",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-001",
    "guild": "holly",
    "name": "Lucky Clover",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Found growing wild along the trail, this four-leaf clover is pressed carefully and kept for luck.",
    "sheetClass": "vsheet-90",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-002",
    "guild": "holly",
    "name": "Easter Egg",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Dyed in bright colors every spring, and somehow always the last one found during the hunt.",
    "sheetClass": "vsheet-90",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-003",
    "guild": "holly",
    "name": "Dreidel",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Spins for a surprisingly long time, landing on a different side nearly every try.",
    "sheetClass": "vsheet-90",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-004",
    "guild": "holly",
    "name": "Celebratory Maracas",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Shaken loudly at nearly every celebration Holly's ever thrown, rain or shine.",
    "sheetClass": "vsheet-90",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-005",
    "guild": "holly",
    "name": "Cherry Blossom Crown",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Woven fresh from real enchanted blossoms every spring. It never wilts and smells of fresh rain and blossoms. Worn by Holly on happy celebrations.",
    "sheetClass": "vsheet-90",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-006",
    "guild": "holly",
    "name": "Rainbow Kite",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Catches the wind easily, trailing every color of the rainbow behind it as it climbs.",
    "sheetClass": "vsheet-91",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-007",
    "guild": "holly",
    "name": "Nowruz Painted Egg",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Painted in bright, hopeful colors to welcome the new year, a tradition Holly loves every spring.",
    "sheetClass": "vsheet-91",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-008",
    "guild": "holly",
    "name": "Yule Log Candle",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns slowly through the longest night of the year, filling the room with a warm, woodsy scent.",
    "sheetClass": "vsheet-91",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-009",
    "guild": "holly",
    "name": "Dragon Dance Mask",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bright red and gold, worn during the liveliest parade of the year.",
    "sheetClass": "vsheet-91",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-010",
    "guild": "holly",
    "name": "St. Lucia Candle Crown",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn during the darkest days of winter, its candles a small bright promise that light always comes back.",
    "sheetClass": "vsheet-91",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-011",
    "guild": "holly",
    "name": "Sparkler",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns fast and bright, gone in under a minute but always worth lighting again.",
    "sheetClass": "vsheet-92",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-012",
    "guild": "holly",
    "name": "Chinese Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows a soft warm red, hung outside during the biggest celebrations of the year.",
    "sheetClass": "vsheet-92",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-013",
    "guild": "holly",
    "name": "Mardi Gras Beads",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Bright, plastic, and somehow always in exactly the right colors for the celebration.",
    "sheetClass": "vsheet-92",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-014",
    "guild": "holly",
    "name": "Enchanted Fall Pumpkin",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Grows a little bigger every October, no matter how big it already was the year before.",
    "sheetClass": "vsheet-92",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-015",
    "guild": "holly",
    "name": "Autumn Maple Leaf",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Pressed and kept flat, this leaf still holds its bright red color long after fall's ended.",
    "sheetClass": "vsheet-92",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-016",
    "guild": "holly",
    "name": "Ground Hogs Day Puppet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Pops out of its little burrow every February, though its shadow prediction is right about half the time.",
    "sheetClass": "vsheet-93",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-017",
    "guild": "holly",
    "name": "Snowflake Crystal",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "No two are ever quite alike, though Holly swears she's found a few very close matches.",
    "sheetClass": "vsheet-93",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-018",
    "guild": "holly",
    "name": "Candy Cane",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Striped red and white, and somehow always the first thing to disappear from the holiday bowl.",
    "sheetClass": "vsheet-93",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-019",
    "guild": "holly",
    "name": "Gingerbread Cookie",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Baked fresh every winter, decorated a little differently by whoever's icing that year.",
    "sheetClass": "vsheet-93",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-020",
    "guild": "holly",
    "name": "Magical Leprechaun Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Tips itself slightly whenever luck's about to turn — or so Holly claims.",
    "sheetClass": "vsheet-93",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-021",
    "guild": "holly",
    "name": "Lotus Candle",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Floats gently on water, flame flickering softly even in a light breeze.",
    "sheetClass": "vsheet-94",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-022",
    "guild": "holly",
    "name": "Trick or Treat Bag",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Never quite as full as you remember packing it, somehow, by the end of the night.",
    "sheetClass": "vsheet-94",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-023",
    "guild": "holly",
    "name": "Witch's Broom Stick",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "More decorative than functional, though Holly swears it's swept a floor or two in its time.",
    "sheetClass": "vsheet-94",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-024",
    "guild": "holly",
    "name": "Santa's Milk and Cookie Plate",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Always set out the same way, every December, and always somehow empty by morning.",
    "sheetClass": "vsheet-94",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-025",
    "guild": "holly",
    "name": "North Pole Sign Post",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Points in a dozen directions at once, distances listed in miles nobody's ever actually measured.",
    "sheetClass": "vsheet-94",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-026",
    "guild": "holly",
    "name": "Lucky Horseshoe",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Hung the right way up, always, for luck — Holly's very particular about that detail.",
    "sheetClass": "vsheet-95",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-027",
    "guild": "holly",
    "name": "Floating Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Released into the sky during the guild's quietest celebrations, drifting until it's just a tiny light in the distance.",
    "sheetClass": "vsheet-95",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-028",
    "guild": "holly",
    "name": "Festival Mask",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Brightly painted and reused every year, a little more character added to it each time.",
    "sheetClass": "vsheet-95",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-029",
    "guild": "holly",
    "name": "Conversation Heart Candy",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each candy carries a different tiny message, though half of them are too faded to read anymore. Holly keeps a bowl out every February.",
    "sheetClass": "vsheet-95",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-030",
    "guild": "holly",
    "name": "Pot of Gold",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Sits at the end of every rainbow Holly's ever chased — though the gold inside seems to be exactly the same amount every time.",
    "sheetClass": "vsheet-95",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-031",
    "guild": "holly",
    "name": "Rainbow Pinwheel",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Spins even without wind, somehow, cycling through every color as it turns. Holly hands these out at nearly every celebration.",
    "sheetClass": "vsheet-96",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-032",
    "guild": "holly",
    "name": "Chocolate Bunny",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Hollow, as tradition demands, and gone within a day of any spring celebration Holly hosts.",
    "sheetClass": "vsheet-96",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-033",
    "guild": "holly",
    "name": "MLK I have a dream pim",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Worn every January to honor a dream that changed the world. Holly keeps hers pinned to her jacket all month long.",
    "sheetClass": "vsheet-96",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-034",
    "guild": "holly",
    "name": "Sunflower Bouquet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "These sunflowers somehow always face whoever's holding them, no matter which way the actual sun is.",
    "sheetClass": "vsheet-96",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-035",
    "guild": "holly",
    "name": "Enchanted Pumpkin Spice Mug",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Fills itself with exactly the right amount of warm spiced drink, every single autumn, without fail.",
    "sheetClass": "vsheet-96",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-036",
    "guild": "holly",
    "name": "Santa Clause Figurine",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A tiny, cheerful figurine that Holly sets out the same week every December, in the exact same spot on the shelf.",
    "sheetClass": "vsheet-97",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-037",
    "guild": "holly",
    "name": "Jack-o'-Lantern",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Carved fresh every October, this pumpkin's grin somehow looks a little different depending on who's looking at it.",
    "sheetClass": "vsheet-97",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-038",
    "guild": "holly",
    "name": "Cornucopia",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Overflowing with more autumn harvest than should physically fit inside, this horn never seems to run out during Holly's Thanksgiving spread.",
    "sheetClass": "vsheet-97",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-039",
    "guild": "holly",
    "name": "Evergreen Wreath",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Stays perfectly green all winter long, hung on Holly's door the same day, every single year.",
    "sheetClass": "vsheet-97",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-040",
    "guild": "holly",
    "name": "Golden Christmas Stocking",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Never quite empty on Christmas morning, no matter how big or small the gift inside turns out to be.",
    "sheetClass": "vsheet-97",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-041",
    "guild": "holly",
    "name": "Christmas Countdown Paper Chain",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Torn off one link at a time, this chain somehow always has exactly the right number of days left, however close the holiday actually is.",
    "sheetClass": "vsheet-98",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-042",
    "guild": "holly",
    "name": "Valentine Mailbox",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Stuffed with cards every February, more than Holly could possibly have written herself.",
    "sheetClass": "vsheet-98",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-043",
    "guild": "holly",
    "name": "Heart Locket",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Opens to reveal a tiny picture that changes depending on who's holding it — always someone the holder cares about.",
    "sheetClass": "vsheet-98",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-044",
    "guild": "holly",
    "name": "New Year's Party Horn",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Blown once a year, at exactly midnight, and somehow never once out of breath before the countdown's over.",
    "sheetClass": "vsheet-98",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-045",
    "guild": "holly",
    "name": "New Year's Eve Ball",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Drops slowly from the top of the Festival Guild's tallest tower every single New Year's Eve, glittering the whole way down.",
    "sheetClass": "vsheet-98",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-046",
    "guild": "holly",
    "name": "Precious Stones Snow Globe",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shake it and real, tiny gemstones swirl instead of ordinary snow, catching the light beautifully as they settle.",
    "sheetClass": "vsheet-99",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-047",
    "guild": "holly",
    "name": "Golden Nutcracker",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved for a Christmas that happened so long ago nobody quite remembers which one, this nutcracker still snaps open walnuts with a satisfying click. Holly keeps him proudly displayed all December.",
    "sheetClass": "vsheet-99",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-048",
    "guild": "holly",
    "name": "Leprechaun's Treasure Chest",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Small enough to fit in your pocket and surprisingly heavy for its size, this chest is said to always be exactly one gold coin lighter than whoever's counting expects. Holly's given up trying to keep track.",
    "sheetClass": "vsheet-99",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-049",
    "guild": "holly",
    "name": "Jeweled Minora",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Each candle holder on this menorah is set with a different gemstone, one for every night it's meant to be lit. Holly polishes it fresh before every celebration.",
    "sheetClass": "vsheet-99",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-050",
    "guild": "holly",
    "name": "Enchanted Spring Tulips",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "These tulips bloom the very same week every single spring, no matter what the weather's been doing. Holly says they're the surest sign the season's finally turning.",
    "sheetClass": "vsheet-99",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-051",
    "guild": "holly",
    "name": "Firework Dragon Puppet",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Wave this puppet through the air just right and sparks trail behind it like a dragon actually breathing fire. Holly saves it for the biggest celebrations of the year.",
    "sheetClass": "vsheet-100",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-052",
    "guild": "holly",
    "name": "Holly's Founders Flag",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This flag has flown over every single celebration the Festival Guild has ever thrown, from the very first one Holly organized. It's covered in confetti that never quite washes off.",
    "sheetClass": "vsheet-100",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-053",
    "guild": "holly",
    "name": "Key to Haunted Mansion",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Holly borrowed this key for a Halloween celebration years ago and, somehow, never quite got around to giving it back. She insists that's a story for another day.",
    "sheetClass": "vsheet-100",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-054",
    "guild": "holly",
    "name": "Pumpkin Carriage",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Big enough to actually ride in, this carved pumpkin carriage rolls smoothly on wheels nobody remembers attaching. Holly brings it out every fall festival.",
    "sheetClass": "vsheet-100",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-055",
    "guild": "holly",
    "name": "Enchanted Christmas Tree Star Topper",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This star doesn't just sparkle — it hums a faint, cheerful tune whenever it's placed at the very top of a tree. Holly says a tree isn't finished without it.",
    "sheetClass": "vsheet-100",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-056",
    "guild": "holly",
    "name": "Woodland Elf Sculpture",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from a single piece of driftwood, this little elf statue has watched over more winter celebrations than anyone currently in the guild. Holly considers her part of the family. She is said to come alive during the night.",
    "sheetClass": "vsheet-101",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-057",
    "guild": "holly",
    "name": "Golden Ruldolph Harth Sculpture",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Antlers gleaming and nose glowing faintly warm, this sculpture sits by the hearth every single winter without fail. Holly swears the nose gets brighter the closer the holiday gets.",
    "sheetClass": "vsheet-101",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-058",
    "guild": "holly",
    "name": "Three-Tier Birthday Cake",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This cake never actually gets smaller no matter how many slices are cut from it. Holly's stopped questioning it and just keeps serving.",
    "sheetClass": "vsheet-101",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-059",
    "guild": "holly",
    "name": "Mother Earth Day Pin",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A simple pin shaped like the whole planet, worn every spring to remind everyone in the Festival Guild why the celebrations matter in the first place. Holly wears hers the whole month, not just the one day.",
    "sheetClass": "vsheet-101",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-060",
    "guild": "holly",
    "name": "Four Seasons Bonsai",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This tiny tree somehow shows all four seasons at once — one branch in bloom, one bare, one gold, one green. Holly waters it exactly the same no matter the season.",
    "sheetClass": "vsheet-101",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-061",
    "guild": "holly",
    "name": "Melting glass Snowman",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from glass instead of actual snow, this little snowman never melts no matter how warm it gets near him. Holly displays him proudly, even in July.",
    "sheetClass": "vsheet-102",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-062",
    "guild": "holly",
    "name": "Cupids Golden Bow",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Strung with something that isn't quite bowstring and pulls back with almost no effort at all, this bow is said to have started more than one lasting friendship. Holly keeps hers safely out of reach of anyone in a mischievous mood.",
    "sheetClass": "vsheet-102",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-063",
    "guild": "holly",
    "name": "Holly's Portrait",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This is Holly, painted mid-celebration the way she always looks during a festival. It's one of the guild's most cheerful relics, and one of its most prized.",
    "sheetClass": "vsheet-102",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-064",
    "guild": "holly",
    "name": "Golden Sleigh",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Polished to a blinding shine every December, this sleigh has carried Holly through more winter celebrations than she can count. It never needs new runners — somehow, they never wear down.",
    "sheetClass": "vsheet-102",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-065",
    "guild": "holly",
    "name": "Crystal Christmas Tree",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved entirely from clear crystal, this little tree catches and scatters light across the room whenever a candle's lit nearby. Holly sets it out the same week every single year.",
    "sheetClass": "vsheet-102",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-066",
    "guild": "holly",
    "name": "Giant Piñata",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Bigger than anyone expects and packed with more candy than seems physically possible, this piñata has been the centerpiece of at least a dozen Festival Guild celebrations. Holly refuses to say how she refills it.",
    "sheetClass": "vsheet-103",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-067",
    "guild": "holly",
    "name": "Royal Gingerbread Castle",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Built fresh every winter and somehow never going stale, this gingerbread castle towers over the rest of the holiday table. Holly adds one new turret every year.",
    "sheetClass": "vsheet-103",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-068",
    "guild": "holly",
    "name": "Mystical Beach Umbrella",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This umbrella somehow always finds the shade no matter where the sun is, tilting on its own to keep whoever's underneath perfectly cool. Holly brings hers out for every summer celebration.",
    "sheetClass": "vsheet-103",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-069",
    "guild": "holly",
    "name": "Glowing Eternal Festival Bell",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Rung to open every single celebration the Festival Guild has ever held, this bell hasn't gone silent once in all that time. Holly rings it herself, every year, without fail.",
    "sheetClass": "vsheet-103",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-070",
    "guild": "holly",
    "name": "Snowflake Crown",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "No two points on this crown are exactly alike, just like the snowflakes it's modeled after. Holly only wears it during the very first snow of the season.",
    "sheetClass": "vsheet-103",
    "bgPos": "-160px -160px"
  },
  {
    "id": "SEA-071",
    "guild": "holly",
    "name": "Bottomless Gift Box",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Reach in and there's always one more gift inside, no matter how many times you've already pulled something out. Holly's stopped trying to figure out where they all come from.",
    "sheetClass": "vsheet-104",
    "bgPos": "-0px -0px"
  },
  {
    "id": "SEA-072",
    "guild": "holly",
    "name": "Great Pumpkin Crown",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Carved from the largest pumpkin ever grown near the Festival Guild's fields, this crown is surprisingly light for something so enormous. Holly wears it proudly every autumn.",
    "sheetClass": "vsheet-104",
    "bgPos": "-160px -0px"
  },
  {
    "id": "SEA-073",
    "guild": "holly",
    "name": "Enchanted Rose",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This rose never wilts, no matter the season, staying in perfect bloom through every single one of Holly's celebrations. Nobody's quite sure what keeps it blooming. Holly isn't telling.",
    "sheetClass": "vsheet-104",
    "bgPos": "-320px -0px"
  },
  {
    "id": "SEA-074",
    "guild": "holly",
    "name": "Golden Liberty Torch",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "A torch said to have been lit during the very first celebration the Festival Guild ever held, and never allowed to go out since. Holly personally checks on its flame every single year.",
    "sheetClass": "vsheet-104",
    "bgPos": "-0px -160px"
  },
  {
    "id": "SEA-075",
    "guild": "holly",
    "name": "Throne of all Seasons",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "A single throne that somehow reflects every season and holiday the Festival Guild celebrates, shifting its decoration throughout the year. Holly built it herself, one celebration at a time.",
    "sheetClass": "vsheet-104",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-001",
    "guild": "ember",
    "name": "Blacksmith's Torch",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Burns steady and hot, used for everything from forging swords to lighting the castle's evening fires.",
    "sheetClass": "vsheet-105",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-002",
    "guild": "ember",
    "name": "Dragon Egg Warmer",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Keeps a dragon egg at exactly the right temperature, day and night, without ever needing to be refueled.",
    "sheetClass": "vsheet-105",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-003",
    "guild": "ember",
    "name": "Iron Cauldron",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Dented from years of use, this cauldron has cooked more stew than anyone in the castle kitchen can count.",
    "sheetClass": "vsheet-105",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-004",
    "guild": "ember",
    "name": "Enchanted Matchflint",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Strikes a spark every single time, even in the wind and rain that usually kill an ordinary match.",
    "sheetClass": "vsheet-105",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-005",
    "guild": "ember",
    "name": "Knight's Flame Shield",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Painted with a flame emblem and scorched just slightly at the edges from real tournament use.",
    "sheetClass": "vsheet-105",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-006",
    "guild": "ember",
    "name": "Enchanted Castle Key",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Opens every door in the castle except, mysteriously, the one it was originally cut for.",
    "sheetClass": "vsheet-106",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-007",
    "guild": "ember",
    "name": "Castle Hearth Poker",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn smooth from years of stoking the same fire, night after night, without fail.",
    "sheetClass": "vsheet-106",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-008",
    "guild": "ember",
    "name": "Alchemist's Fire Vial",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small glass vial that flares briefly to life whenever it's shaken — useful for lighting a fire in a hurry.",
    "sheetClass": "vsheet-106",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-009",
    "guild": "ember",
    "name": "Torchbearer's Lantern",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carried at the front of every castle procession, this lantern's flame has never once gone out.",
    "sheetClass": "vsheet-106",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-010",
    "guild": "ember",
    "name": "Dragon Scale Gauntlet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Fitted with real dragon scale plating, this gauntlet has protected more than one hand from stray sparks.",
    "sheetClass": "vsheet-106",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-011",
    "guild": "ember",
    "name": "Molten Lava Goblet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Holds boiling lava from the most dangerous volcano in the world. The lava never cools because of the enchanted goblet.",
    "sheetClass": "vsheet-107",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-012",
    "guild": "ember",
    "name": "Blazing Banner",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Flown above the castle gates. When the wind howls the banner ignites in fire to ward away any darkness or danger.",
    "sheetClass": "vsheet-107",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-013",
    "guild": "ember",
    "name": "Forge Hammer",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Heavy, well-worn, and responsible for shaping half the metalwork currently in the castle.",
    "sheetClass": "vsheet-107",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-014",
    "guild": "ember",
    "name": "Ember-Lit Toy Crown",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small, glowing toy crown, popular with the youngest members of the Flame Guild.",
    "sheetClass": "vsheet-107",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-015",
    "guild": "ember",
    "name": "Dragonfire Scepter",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carried during ceremonies, this scepter's tip glows faintly warm even when nothing's actually burning.",
    "sheetClass": "vsheet-107",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-016",
    "guild": "ember",
    "name": "Enchanted Phoenix Feather",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Anyone who possesses this feather has the power to be brought back to life when it glows red and orange on a full moon.",
    "sheetClass": "vsheet-108",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-017",
    "guild": "ember",
    "name": "Knight's Flaming Sword (Toy)",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A training sword with a glowing tip, popular with young squires learning the basics.",
    "sheetClass": "vsheet-108",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-018",
    "guild": "ember",
    "name": "Poison Vial",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sealed tight and clearly labeled, this vial is kept locked away — more for study than actual use.",
    "sheetClass": "vsheet-108",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-019",
    "guild": "ember",
    "name": "Dragon Riders Saddle",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn smooth from real flight, this saddle has carried more than a few nervous first-time riders.",
    "sheetClass": "vsheet-108",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-020",
    "guild": "ember",
    "name": "Fireball Canon",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Fires a small, controlled burst of flame — mostly used for signaling, occasionally for celebration.",
    "sheetClass": "vsheet-108",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-021",
    "guild": "ember",
    "name": "Dragon Rider's Cape",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Scorched slightly at the hem from close encounters with dragon breath, worn proudly anyway.",
    "sheetClass": "vsheet-109",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-022",
    "guild": "ember",
    "name": "Pheonix Hand Mirror",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "The reflection in this mirror seems to shimmer faintly, like heat rising off a summer road.",
    "sheetClass": "vsheet-109",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-023",
    "guild": "ember",
    "name": "Ember Knight Helmet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Dented from tournament combat and polished back up more times than anyone can count.",
    "sheetClass": "vsheet-109",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-024",
    "guild": "ember",
    "name": "Fire Wizard's Hat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Tall, pointed, and slightly singed at the very tip from one too many spell mishaps.",
    "sheetClass": "vsheet-109",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-025",
    "guild": "ember",
    "name": "Torch-Lit Treasure Map",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Drawn by torchlight, this map leads the owner through any fiery or difficult situation.",
    "sheetClass": "vsheet-109",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-026",
    "guild": "ember",
    "name": "Monestary Book of Prayers",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Kept in the castle's quiet corner, this book is read more for comfort than for any actual spellwork.",
    "sheetClass": "vsheet-110",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-027",
    "guild": "ember",
    "name": "Wizards Ember Compass",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Points not toward north, but toward the nearest source of warmth — handy on cold castle nights.",
    "sheetClass": "vsheet-110",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-028",
    "guild": "ember",
    "name": "Iron Dragon Statue",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Cast in solid iron, this small dragon statue guards the entrance to the Flame Guild's main hall.",
    "sheetClass": "vsheet-110",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-029",
    "guild": "ember",
    "name": "Enchanted Forge Hammer",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This hammer strikes true every single time, landing exactly where the smith intended, no matter how tired their arm's gotten.",
    "sheetClass": "vsheet-110",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-030",
    "guild": "ember",
    "name": "Dragon Egg Nightlight",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Warm and softly glowing, this egg-shaped nightlight has never once gone cold, even through the coldest castle winters.",
    "sheetClass": "vsheet-110",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-031",
    "guild": "ember",
    "name": "Pheonix Scouts Spyglass",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Looking through this spyglass, distant campfires seem to glow just a little brighter than they really are — useful for spotting friendly camps from far off.",
    "sheetClass": "vsheet-111",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-032",
    "guild": "ember",
    "name": "Knight's Armor",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Scuffed in all the right places to prove it's actually been worn into battle, not just polished for show.",
    "sheetClass": "vsheet-111",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-033",
    "guild": "ember",
    "name": "Fire Rune Sword",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Runes etched along the blade glow faintly warm whenever danger's close, giving its wielder just enough warning to be ready.",
    "sheetClass": "vsheet-111",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-034",
    "guild": "ember",
    "name": "Stolen Treasure",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Nobody in the Flame Guild will say exactly who it was stolen from, only that it's been worth the trouble ever since.",
    "sheetClass": "vsheet-111",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-035",
    "guild": "ember",
    "name": "Enchanted Flame Harp",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Strum this harp and each note seems to flicker like a tiny flame in the air before fading out.",
    "sheetClass": "vsheet-111",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-036",
    "guild": "ember",
    "name": "Fire Goggles",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "These goggles cut straight through smoke, letting the wearer see clearly even deep inside the thickest blaze.",
    "sheetClass": "vsheet-112",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-037",
    "guild": "ember",
    "name": "Blue Flame Church Bell",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This bell tolls with a strange blue-tinted flame instead of a normal ring, audible from well outside the castle walls.",
    "sheetClass": "vsheet-112",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-038",
    "guild": "ember",
    "name": "Eternal Flame Candle",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This candle has never once needed relighting, no matter how many storms have rolled through the castle.",
    "sheetClass": "vsheet-112",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-039",
    "guild": "ember",
    "name": "Ember Wizard's Broom",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "More for flying than sweeping, this broom has carried more than one wizard clear across the Flame Guild's kingdom.",
    "sheetClass": "vsheet-112",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-040",
    "guild": "ember",
    "name": "Small Fireforged Blue Tiara",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Forged in blue flame instead of ordinary fire, this tiara stays cool to the touch despite how it was made.",
    "sheetClass": "vsheet-112",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-041",
    "guild": "ember",
    "name": "Castle Hearth Dragon Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Carved to sit beside the hearth, this little dragon statue seems to lean just slightly closer to the fire every winter.",
    "sheetClass": "vsheet-113",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-042",
    "guild": "ember",
    "name": "Dragonfire tournament trumpet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Blown to open every tournament the Flame Guild's ever hosted, this trumpet's blast trails a faint wisp of smoke.",
    "sheetClass": "vsheet-113",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-043",
    "guild": "ember",
    "name": "Knight's Dragonscale Boots",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Fitted with real dragon scale soles, these boots have walked through embers without a single scorch mark.",
    "sheetClass": "vsheet-113",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-044",
    "guild": "ember",
    "name": "Enchanted Tavern Mug",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This mug never quite runs empty, no matter how many times it's tipped back — though nobody's tested it past a third round.",
    "sheetClass": "vsheet-113",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-045",
    "guild": "ember",
    "name": "Torchlight Guardian Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Standing watch just inside the castle gates, this statue's torch never goes out, rain or shine.",
    "sheetClass": "vsheet-113",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-046",
    "guild": "ember",
    "name": "Dragon Emperors War Horn",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Blown only in the direst circumstances, this horn's call is said to carry clear across the whole kingdom.",
    "sheetClass": "vsheet-114",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-047",
    "guild": "ember",
    "name": "Dragon Whisperers Ember Flute",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Play the right note on this flute and even the wildest dragon will pause to listen. Ember learned three notes before giving up — dragons are stubborn critics.",
    "sheetClass": "vsheet-114",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-048",
    "guild": "ember",
    "name": "Ember Feather Crown",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Woven from feathers Ember sheds during her biggest growth spurts, this crown radiates warmth without ever burning the wearer. It's one of her favorite things to lend out.",
    "sheetClass": "vsheet-114",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-049",
    "guild": "ember",
    "name": "Fire Throwing Ninja Star",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Forged in dragonfire and cooled just enough to throw safely, this star trails a thin line of sparks wherever it lands. Castle guards use them for signal flares as often as weapons.",
    "sheetClass": "vsheet-114",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-050",
    "guild": "ember",
    "name": "Ember Scribes Ink Pot",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "The ink inside never runs dry and glows faintly orange in the dark. Castle scribes fight over who gets to use it for the important scrolls.",
    "sheetClass": "vsheet-114",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-051",
    "guild": "ember",
    "name": "Ember Feather Shield",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Lighter than it looks and warm to the touch, this shield is built from feathers Ember willingly gave up for the cause. It's blocked more sparks than anyone's bothered to count.",
    "sheetClass": "vsheet-115",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-052",
    "guild": "ember",
    "name": "Dragon Hunting Fire Goggles",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "These goggles can spot a dragon up to 20 miles away, giving an advantage to those who wear them. Ember insists she's never actually been spotted with them.",
    "sheetClass": "vsheet-115",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-053",
    "guild": "ember",
    "name": "Dragonfire Warhammer",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Forged in the hottest part of the castle's furnace, this hammer stays warm for days after it's used. It takes real strength just to lift it off the rack.",
    "sheetClass": "vsheet-115",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-054",
    "guild": "ember",
    "name": "Red Ruby Pickaxe",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved out of the kingdom's biggest ruby. This axe was made for climbing near active volcanoes.",
    "sheetClass": "vsheet-115",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-055",
    "guild": "ember",
    "name": "Knight's Thorny Round Shield",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Ringed with iron thorns that catch and snap incoming blades, this shield looks intimidating and works even better than it looks. It's seen more tournaments than any knight currently serving.",
    "sheetClass": "vsheet-115",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-056",
    "guild": "ember",
    "name": "Sorcerors Treasure Chest",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Locked with a spell instead of a key, this chest only opens for whoever solves the riddle carved into its lid. Nobody currently in the guild has managed it yet.",
    "sheetClass": "vsheet-116",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-057",
    "guild": "ember",
    "name": "Dragon Egg Pearl Necklace",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Each pearl on this necklace was found nestled inside a hatched dragon egg — rare, warm to the touch, and said to bring good luck to whoever wears it. Ember has three. She won't say how.",
    "sheetClass": "vsheet-116",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-058",
    "guild": "ember",
    "name": "Ember's Pheonix Feather Christmas Tree",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Decorated entirely in phoenix feathers instead of tinsel, this tiny tree never needs watering and glows warm orange through the coldest months. Ember lights it every winter without fail.",
    "sheetClass": "vsheet-116",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-059",
    "guild": "ember",
    "name": "Dragon Head Helmet",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved to look exactly like a snarling dragon, this helmet has scared off more than one nervous new recruit before they realized it wasn't real. Ember thinks that's half the fun.",
    "sheetClass": "vsheet-116",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-060",
    "guild": "ember",
    "name": "Glass Fire Heart",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Blown from molten glass and still glowing faintly orange at its core, this heart-shaped ornament never quite cools all the way down. Ember keeps hers on a shelf far from anything flammable.",
    "sheetClass": "vsheet-116",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-061",
    "guild": "ember",
    "name": "Ember's Masquerade Mask",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Worn only once a year, during the Flame Guild's grandest celebration, this mask is trimmed in real feathers that catch the torchlight beautifully. Ember designed it herself.",
    "sheetClass": "vsheet-117",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-062",
    "guild": "ember",
    "name": "Dragon bone Dice",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Carved from a bone too heavy to have come from anything but a dragon, these dice always seem to land exactly how the castle needs them to. Nobody's proven they're rigged. Nobody's proven they're not.",
    "sheetClass": "vsheet-117",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-063",
    "guild": "ember",
    "name": "Flame Guild Flag",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This banner has flown over every tournament the Flame Guild has ever hosted, scorched at the edges from a hundred victories. Wherever it flies, Ember isn't far behind.",
    "sheetClass": "vsheet-117",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-064",
    "guild": "ember",
    "name": "Magical Dragon Scale",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This single scale shifts color depending on the mood of whoever's holding it — warm gold when calm, deep red when determined. Ember says it's picked her mood correctly every time.",
    "sheetClass": "vsheet-117",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-065",
    "guild": "ember",
    "name": "Dragon Tooth Amulet",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Pulled from a dragon who gave it up willingly, according to castle legend, this amulet is said to protect the wearer from the worst kind of burns. Ember wears hers under her jacket, always.",
    "sheetClass": "vsheet-117",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-066",
    "guild": "ember",
    "name": "Supreme Ruler Fire Ring",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Set with a stone that never stops smoldering, this ring was forged for whoever leads the Flame Guild's biggest tournaments. It's passed down, never sold.",
    "sheetClass": "vsheet-118",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-067",
    "guild": "ember",
    "name": "Dragon Scale Knight's Flaming Armor",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Every plate on this armor is a real dragon scale, fitted together by a smith who spent a lifetime perfecting the join. It's said to be nearly impossible to burn through — fitting, for a knight of the Flame Guild.",
    "sheetClass": "vsheet-118",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-068",
    "guild": "ember",
    "name": "Ember Portrait",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "This is Ember, wings spread and jacket blazing, exactly as she looks the moment a new streak begins. Hang it somewhere special to remind you to keep learning every day.",
    "sheetClass": "vsheet-118",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-069",
    "guild": "ember",
    "name": "Ember's Ruby Amulet",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Set with a ruby that pulses gently warm, almost like a heartbeat, this amulet has never once gone cold — not even the day Ember first found it. She hasn't taken it off since.",
    "sheetClass": "vsheet-118",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-070",
    "guild": "ember",
    "name": "Golden Dragon Tooth Hatchet",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Forged around a single dragon tooth instead of ordinary steel, this hatchet has never needed sharpening in all the years it's been part of the Flame Guild's collection.",
    "sheetClass": "vsheet-118",
    "bgPos": "-160px -160px"
  },
  {
    "id": "STR-071",
    "guild": "ember",
    "name": "Royal Treasurey Ember Coin",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Minted for a treasury that hasn't existed in centuries, this coin still gleams like it was struck yesterday. Ember keeps hers as a reminder of how far the guild's come.",
    "sheetClass": "vsheet-119",
    "bgPos": "-0px -0px"
  },
  {
    "id": "STR-072",
    "guild": "ember",
    "name": "Wizard's Blazing Orb",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Cradled carefully and never set down on anything flammable, this orb burns with a flame that never spreads, never dims, and never quite goes out.",
    "sheetClass": "vsheet-119",
    "bgPos": "-160px -0px"
  },
  {
    "id": "STR-073",
    "guild": "ember",
    "name": "Magical Shape Shifting Potion",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "One sip and the drinker briefly takes on the shape of something else entirely — a dragon, a knight, once memorably a teapot. Ember only lets trusted guild members try it.",
    "sheetClass": "vsheet-119",
    "bgPos": "-320px -0px"
  },
  {
    "id": "STR-074",
    "guild": "ember",
    "name": "Blazing Tournament Trophy",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Awarded only once, to whoever burns brightest across every streak challenge the Flame Guild has ever held. Even Ember admits she's never come close to earning this one herself.",
    "sheetClass": "vsheet-119",
    "bgPos": "-0px -160px"
  },
  {
    "id": "STR-075",
    "guild": "ember",
    "name": "Flaming Throne of Ember",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "This is Ember's own throne, forged in dragonfire and kept burning day and night at the heart of the Flame Guild. Sitting on it, even for a moment, is the highest honor a streak-keeper can claim.",
    "sheetClass": "vsheet-119",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-001",
    "guild": "atlas",
    "name": "Mummy Wrap Roll",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Unused and still tightly wound, this roll of ancient linen was recovered from a sealed tomb chamber.",
    "sheetClass": "vsheet-120",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-002",
    "guild": "atlas",
    "name": "Roman Oil Lamp",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Simple clay construction, still capable of holding a flame just like it did thousands of years ago.",
    "sheetClass": "vsheet-120",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-003",
    "guild": "atlas",
    "name": "Roman Coin",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Stamped with the face of an emperor nobody currently in the guild can quite agree on identifying.",
    "sheetClass": "vsheet-120",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-004",
    "guild": "atlas",
    "name": "Greek Vase",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Painted with scenes from a story that's been retold so many times, nobody's sure which version is the real one anymore.",
    "sheetClass": "vsheet-120",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-005",
    "guild": "atlas",
    "name": "Viking Helmet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Dented from real use and worn by the fiercest vikings to ever live.",
    "sheetClass": "vsheet-120",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-006",
    "guild": "atlas",
    "name": "Pharaoh's Sandal",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Woven from reeds and remarkably well preserved for something buried thousands of years ago.",
    "sheetClass": "vsheet-121",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-007",
    "guild": "atlas",
    "name": "Viking Horn",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sounds a deep, low note when blown — used to signal everything from mealtime to battle.",
    "sheetClass": "vsheet-121",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-008",
    "guild": "atlas",
    "name": "Viking Comb Carved from Antler",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carved with careful detail, proving even fierce warriors cared about a good hairstyle.",
    "sheetClass": "vsheet-121",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-009",
    "guild": "atlas",
    "name": "Mini Greek Temple Statue",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small, detailed replica of a temple that's stood, in various states, for thousands of years.",
    "sheetClass": "vsheet-121",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-010",
    "guild": "atlas",
    "name": "Roman Glass Perfume Vial",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Tiny and delicate, still faintly scented despite the centuries since it was last opened.",
    "sheetClass": "vsheet-121",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-011",
    "guild": "atlas",
    "name": "Anubis Golden Mask",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn during ceremonies honoring the guardian of the afterlife, gold catching the torchlight beautifully.",
    "sheetClass": "vsheet-122",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-012",
    "guild": "atlas",
    "name": "Roman Sword",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Balanced perfectly for close combat, this sword saw real use in the arms of a real soldier.",
    "sheetClass": "vsheet-122",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-013",
    "guild": "atlas",
    "name": "Nile River Boat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small wooden model of the boats that carried goods, and occasionally pharaohs, up and down the Nile.",
    "sheetClass": "vsheet-122",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-014",
    "guild": "atlas",
    "name": "Mummy Glowing Amulet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Glows faintly warm, a small mystery nobody in the Victory Guild has fully explained.",
    "sheetClass": "vsheet-122",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-015",
    "guild": "atlas",
    "name": "Ancient Writing Tablet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Covered in symbols from a language that took scholars generations to fully decode.",
    "sheetClass": "vsheet-122",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-016",
    "guild": "atlas",
    "name": "Golden Underworld Staff",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Carried by priests responsible for guiding souls safely to the afterlife.",
    "sheetClass": "vsheet-123",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-017",
    "guild": "atlas",
    "name": "Nile Hippopotamus Figurine",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Painted a cheerful blue, this little hippo was a common good-luck charm in ancient Egyptian homes.",
    "sheetClass": "vsheet-123",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-018",
    "guild": "atlas",
    "name": "Remnant of a Pompeii Painting",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A small fragment of fresco, colors still vivid despite everything that happened to the city it came from.",
    "sheetClass": "vsheet-123",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-019",
    "guild": "atlas",
    "name": "Pharaoh's Golden Cat",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Cats were sacred in ancient Egypt, and this little golden statue proves it — carved with real reverence.",
    "sheetClass": "vsheet-123",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-020",
    "guild": "atlas",
    "name": "Stolen Grave Broach",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Nobody in the guild is entirely proud of how this one was acquired. Atlas keeps it anyway.",
    "sheetClass": "vsheet-123",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-021",
    "guild": "atlas",
    "name": "Ancient Egyptian Board Game Piece",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A single carved piece from a game that was popular thousands of years before anyone invented chess.",
    "sheetClass": "vsheet-124",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-022",
    "guild": "atlas",
    "name": "Mosaic Tile from a Pompeii Villa",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A single colored tile, once part of a much larger, much more impressive floor design.",
    "sheetClass": "vsheet-124",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-023",
    "guild": "atlas",
    "name": "Wolf Fang Necklace",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn by Viking warriors as a symbol of strength borrowed from the animal itself.",
    "sheetClass": "vsheet-124",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-024",
    "guild": "atlas",
    "name": "Roman Trumpet",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Sounds a bright, clear note, once used to signal the start of a legion's march.",
    "sheetClass": "vsheet-124",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-025",
    "guild": "atlas",
    "name": "Roman Chariot Wheel",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Worn smooth from real racing, this wheel has clearly seen its share of the arena.",
    "sheetClass": "vsheet-124",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-026",
    "guild": "atlas",
    "name": "Bronze Cloak Pin",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Simple but sturdy, this pin held together the cloaks of soldiers across the ancient world.",
    "sheetClass": "vsheet-125",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-027",
    "guild": "atlas",
    "name": "Egyptian Hieroglyphic",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "A single stone with many symbols written in an ancient language. You can almost decode it by looking at the pictures but not quite.",
    "sheetClass": "vsheet-125",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-028",
    "guild": "atlas",
    "name": "Pegasus Feather",
    "rarity": "common",
    "rarityLabel": "Common",
    "price": 110,
    "desc": "Said to have fallen from the winged horse of Greek legend, this feather is impossibly light.",
    "sheetClass": "vsheet-125",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-029",
    "guild": "atlas",
    "name": "Pharaoh's Golden Staff",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Topped with the head of the hawk God, this staff was carried only by rulers of the highest rank.",
    "sheetClass": "vsheet-125",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-030",
    "guild": "atlas",
    "name": "Gladiator's Shield",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Dented from real combat and polished back up more than once, this shield has seen more arena battles than anyone currently keeping count.",
    "sheetClass": "vsheet-125",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-031",
    "guild": "atlas",
    "name": "Ankh Necklace",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Worn as a symbol of life itself, this pendant gives good luck and fortune to those who find it and wear it.",
    "sheetClass": "vsheet-126",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-032",
    "guild": "atlas",
    "name": "Viking Battle Axe",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Notched along the blade from real use, this axe has clearly seen more than a few real Viking raids.",
    "sheetClass": "vsheet-126",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-033",
    "guild": "atlas",
    "name": "Lapis Lazuli Bead Necklace",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Each bead is carved from the same deep blue stone, prized across the ancient world for its rarity.",
    "sheetClass": "vsheet-126",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-034",
    "guild": "atlas",
    "name": "Dragon Ship Figurehead",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Carved to snarl at the front of a longship, this figurehead was meant to scare off sea monsters before they got close.",
    "sheetClass": "vsheet-126",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-035",
    "guild": "atlas",
    "name": "Roman Senate Scroll",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Written in careful script and sealed with wax, this scroll records a vote that shaped an empire.",
    "sheetClass": "vsheet-126",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-036",
    "guild": "atlas",
    "name": "King Tut's Cursed Amulet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Said to bring misfortune to anyone who removes it from its resting place. Atlas keeps his carefully displayed, never worn.",
    "sheetClass": "vsheet-127",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-037",
    "guild": "atlas",
    "name": "Julius Caesar's Golden Ring",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Engraved with symbols nobody's fully translated, this ring once belonged to one of history's most famous rulers.",
    "sheetClass": "vsheet-127",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-038",
    "guild": "atlas",
    "name": "Wolf Pelt Cape",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Worn by Viking warriors said to fight with the ferocity of the wolves whose pelts they carried.",
    "sheetClass": "vsheet-127",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-039",
    "guild": "atlas",
    "name": "Ice Giant's Tooth",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Massive, jagged, and cold enough to frost over anything nearby, this tooth is said to have come from a creature out of Norse legend.",
    "sheetClass": "vsheet-127",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-040",
    "guild": "atlas",
    "name": "Greek Parthenon Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A detailed miniature of the temple that's stood for thousands of years, right down to its famous columns.",
    "sheetClass": "vsheet-127",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-041",
    "guild": "atlas",
    "name": "Viking Dragon Ship Anchor",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Heavy enough to hold a longship steady through the roughest seas, this anchor has real salt-crusted history behind it.",
    "sheetClass": "vsheet-128",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-042",
    "guild": "atlas",
    "name": "Atlas Founders Flag",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "This flag marks the very first competition Atlas ever won for the Victory Guild — a race he insists he'd still win today. Slow and steady, just like he says.",
    "sheetClass": "vsheet-128",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-043",
    "guild": "atlas",
    "name": "Medusa Golden Snake Bracelet",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shaped like a coiled snake, this bracelet is said to have belonged to someone who survived a look at Medusa herself — and lived to tell about it.",
    "sheetClass": "vsheet-128",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-044",
    "guild": "atlas",
    "name": "Mini Viking Ship",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "A detailed miniature longship, dragon head and all, small enough to sit on a shelf but detailed enough to look ready to sail.",
    "sheetClass": "vsheet-128",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-045",
    "guild": "atlas",
    "name": "Medusa Snake Hairpin",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Shaped like a tiny serpent, this hairpin is a small nod to one of the ancient world's most famous myths.",
    "sheetClass": "vsheet-128",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-046",
    "guild": "atlas",
    "name": "Egyptian Cobra Statue",
    "rarity": "uncommon",
    "rarityLabel": "Uncommon",
    "price": 160,
    "desc": "Carved in the coiled, ready-to-strike pose seen on royal crowns throughout ancient Egypt.",
    "sheetClass": "vsheet-129",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-047",
    "guild": "atlas",
    "name": "Atlas Portrait",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This is Atlas, medal around his neck, painted exactly as he looks after a hard-earned win. He's proud of this portrait — probably too proud, if you ask anyone else in the guild.",
    "sheetClass": "vsheet-129",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-048",
    "guild": "atlas",
    "name": "Egyptian Tomb Treasure",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Recovered from a chamber sealed for thousands of years, this treasure still gleams as though it were buried yesterday. Atlas insists he found it fair and square.",
    "sheetClass": "vsheet-129",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-049",
    "guild": "atlas",
    "name": "Gladiator Armor",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Dented in exactly the right places to prove it saw real combat, this armor once belonged to a fighter who never lost a single match in the arena. Atlas keeps it polished, dents and all.",
    "sheetClass": "vsheet-129",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-050",
    "guild": "atlas",
    "name": "Walrus Ivory Chess Piece",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved centuries ago by hands nobody can name, this single chess piece is missing the rest of its set entirely. Atlas has looked for the others. He hasn't found them yet.",
    "sheetClass": "vsheet-129",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-051",
    "guild": "atlas",
    "name": "Hercules Club",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Heavier than it looks and twice as hard to lift, this club is said to have belonged to the strongest hero of the ancient world. Atlas can barely budge it — which he finds oddly reassuring.",
    "sheetClass": "vsheet-130",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-052",
    "guild": "atlas",
    "name": "King Tut's Ring",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Slipped from a pharaoh's finger and lost for thousands of years before it turned up again, this ring still fits perfectly on whoever's meant to wear it. Atlas has never dared try it on.",
    "sheetClass": "vsheet-130",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-053",
    "guild": "atlas",
    "name": "Frozen Shield of Ice",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Carved from ice that somehow never melts, this shield stays cold to the touch no matter the season. Atlas keeps it as far from the Flame Guild as possible.",
    "sheetClass": "vsheet-130",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-054",
    "guild": "atlas",
    "name": "Cyclops Eye Charm",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This single glass eye seems to follow you around the room no matter where you stand. Atlas swears it's just clever craftsmanship. He still doesn't like looking at it directly.",
    "sheetClass": "vsheet-130",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-055",
    "guild": "atlas",
    "name": "Sphynx Statue",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "This statue has guarded the same riddle for thousands of years, and nobody in the Victory Guild has managed to solve it yet. Atlas has a few guesses. He's kept them to himself.",
    "sheetClass": "vsheet-130",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-056",
    "guild": "atlas",
    "name": "Great Pyramid of Giza Statue",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A near-perfect miniature of the largest pyramid ever built, carved from stone that matches the original almost exactly. Atlas says it took three sculptors and one very patient mule to get it right.",
    "sheetClass": "vsheet-131",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-057",
    "guild": "atlas",
    "name": "Atlas Discus Thrower Statue",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Frozen mid-throw, this statue captures the exact moment an ancient champion let go of the disc. Atlas likes to think he'd have thrown just as far.",
    "sheetClass": "vsheet-131",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-058",
    "guild": "atlas",
    "name": "Athena's Owl Statue",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "Said to represent wisdom itself, this owl statue watches over the Victory Guild's most important decisions. Atlas consults it more than he probably should.",
    "sheetClass": "vsheet-131",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-059",
    "guild": "atlas",
    "name": "Trojan Horse",
    "rarity": "rare",
    "rarityLabel": "Rare",
    "price": 225,
    "desc": "A wooden horse just big enough to hide a very clever plan inside. Atlas keeps his empty, mostly. Mostly.",
    "sheetClass": "vsheet-131",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-060",
    "guild": "atlas",
    "name": "Zeus's Lightning Bolt",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This bolt crackles faintly with real static even sitting still on a shelf. Atlas keeps it well away from anything metal, just to be safe.",
    "sheetClass": "vsheet-131",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-061",
    "guild": "atlas",
    "name": "Thor's Hammer",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Far too heavy for anyone in the Victory Guild to actually lift, this hammer sits proudly on display instead. Atlas has tried. More than once.",
    "sheetClass": "vsheet-132",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-062",
    "guild": "atlas",
    "name": "Poseidon's Trident",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Salt-crusted and cold to the touch no matter the weather, this trident is said to have calmed storms that would've sunk lesser ships. Atlas keeps it near water, out of respect.",
    "sheetClass": "vsheet-132",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-063",
    "guild": "atlas",
    "name": "King Tut's Golden Throne",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Small enough to have been built for a boy king, this golden throne is one of the best-preserved treasures the Victory Guild has ever recovered. Atlas treats it like it's still occupied.",
    "sheetClass": "vsheet-132",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-064",
    "guild": "atlas",
    "name": "Hercules Golden Lion Crown",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Fashioned in the likeness of a lion's mane. This crown gives the person who wears it the power to rule and fight like a lion.",
    "sheetClass": "vsheet-132",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-065",
    "guild": "atlas",
    "name": "Icarus Golden Wings",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "Beautiful, delicate, and famously not built for getting too close to the sun, these wings are kept purely for display. Atlas admires them from a very respectful distance.",
    "sheetClass": "vsheet-132",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-066",
    "guild": "atlas",
    "name": "Mini Golden Colloseum",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "A near-perfect miniature of the greatest arena the ancient world ever built, right down to the tiny archways. Atlas says it took longer to build than the real one, probably.",
    "sheetClass": "vsheet-133",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-067",
    "guild": "atlas",
    "name": "Ra's Eternal Sun Disc",
    "rarity": "epic",
    "rarityLabel": "Epic",
    "price": 350,
    "desc": "This golden disc is warm to the touch even in the coldest room, as though it never quite forgot where it came from. Atlas keeps it somewhere it can always catch a little light.",
    "sheetClass": "vsheet-133",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-068",
    "guild": "atlas",
    "name": "Viking Ice Dragon Scale",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Pulled from a dragon said to live somewhere in the frozen north, this scale stays cold to the touch no matter how long you hold it. Atlas keeps his wrapped, just to be safe.",
    "sheetClass": "vsheet-133",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-069",
    "guild": "atlas",
    "name": "Caesar's Imperial Crown",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Once worn by an emperor who conquered half the known world, this crown still carries real weight — both literally and otherwise. Atlas handles it with both hands.",
    "sheetClass": "vsheet-133",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-070",
    "guild": "atlas",
    "name": "Ancient Olympic Gold Medal",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Awarded at the very first games ever held, this medal predates every trophy the Victory Guild currently has on display. Atlas considers it the true beginning of everything the guild stands for.",
    "sheetClass": "vsheet-133",
    "bgPos": "-160px -160px"
  },
  {
    "id": "VIC-071",
    "guild": "atlas",
    "name": "Bust of Queen Nefertiti",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Carved with a precision that's never quite been matched since, this bust is one of the most recognizable faces from the ancient world. Atlas keeps it carefully displayed, out of direct sunlight.",
    "sheetClass": "vsheet-134",
    "bgPos": "-0px -0px"
  },
  {
    "id": "VIC-072",
    "guild": "atlas",
    "name": "Golden War Chariot",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Built for a conqueror who never lost a single battle, this chariot's wheels still turn smoothly after all these centuries. Atlas has never dared actually ride in it.",
    "sheetClass": "vsheet-134",
    "bgPos": "-160px -0px"
  },
  {
    "id": "VIC-073",
    "guild": "atlas",
    "name": "Golden Fang",
    "rarity": "legendary",
    "rarityLabel": "Legendary",
    "price": 500,
    "desc": "Pulled from a beast no historical record fully agrees on, this golden fang is one of the Victory Guild's strangest and most argued-over relics. Atlas has his own theory. He's not sharing it.",
    "sheetClass": "vsheet-134",
    "bgPos": "-320px -0px"
  },
  {
    "id": "VIC-074",
    "guild": "atlas",
    "name": "Mummies Golden Sarcophagus",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "Recovered from the deepest chamber the Victory Guild has ever explored, this sarcophagus is said to belong to a ruler whose empire outlasted every rival civilization. Nobody has ever fully translated what's written across it.",
    "sheetClass": "vsheet-134",
    "bgPos": "-0px -160px"
  },
  {
    "id": "VIC-075",
    "guild": "atlas",
    "name": "Golden Ice Dragon Throne",
    "rarity": "mythic",
    "rarityLabel": "Mythic",
    "price": 800,
    "desc": "A throne built from a conqueror's treasury and frozen in place by a Viking legend nobody can quite explain. Atlas calls it the single greatest prize in the whole Victory Guild.",
    "sheetClass": "vsheet-134",
    "bgPos": "-160px -160px"
  }
];

export default RELIC_CATALOG;
